
const translations = {
    "Notice!": "Huomio!",
    "Are you sure that you want to delete this?": "Oletko varma, että haluat poistaa tämän?",
    "Confirm": "Vahvista",
    "Cancel": "Peruuta",
    "Min": "Minimi",
    "Max": "Maksimi",
    "Before": "Ennen",
    "After": "Jälkeen",
    "w": "w",
    "week": "viikko",
    "weeks": "viikkoa",
    "d": "pv",
    "day": "päivä",
    "days": "päivää",
    "Due date": "Eräpäivä",
    "Start date": "Alkamispäivä",
    "Internal date": "Sisäinen päivämäärä",
    "Notes": "Merkinnät",
    "Document": "Dokumentti",
    "Email": "Sähköpostiosoite",
    "Billing": "Laskutus",
    "Add": "Lisää",
    "Archived": "Arkistoidut",
    "Cancelled": "Peruttu ",
    "Active": "Aktiivinen",
    "Inactive": "Passiivinen",
    "Client company": "Asiakasyritys",
    "General info": "Yleistä",
    "Digitisation of client documents": "Asiakasasiakirjojen digitointi",
    "Client portal": "Asiakasportaali",
    "Documents": "Dokumentit",
    "Members": "Jäsenet",
    "Preferences": "Asetukset",
    "Yes": "Kyllä",
    "No": "Ei",
    "Total hours": "Tunnit yhteensä",
    "Extra hours": "Lisätunnit",
    "Client": "Asiakas",
    "Tasks": "Tehtävät ",
    "Disable Uku’s task templates": "Poista Ukun tehtävämallit käytöstä",
    "Set the estimation as time when the exact value is not entered": "Aseta tehtävän suoritusajaksi arvioitu aika, jos tarkkaa aikaa ei ole syötetty",
    "Checklist must be completed to finish the task": "Tarkistuslistan on oltava valmis, jotta tehtävän voi saada valmiiksi",
    "Disable topic management for members": "Aiheiden hallinnan poistaminen käytöstä jäseniltä",
    "Disable time edit for members": "Poista jäsenten ajan muokkaus käytöstä",
    "Allow time entries in future": "Salli aikamerkinnät tulevaisuudessa",
    "Show all dependent tasks in the calendar": "Show all dependent tasks in the calendar",
    "Clients": "Asiakkaat",
    "Disable adding new clients for members": "Poista uusien asiakkaiden lisääminen käytöstä jäsenille",
    "Only administrators can edit documents": "Vain järjestelmänvalvojat voivat muokata tiedostoja",
    "Allow digitisation of client documents": "Salli asiakasasiakirjojen digitointi",
    "Use my Microsoft account": "Microsoft-tilin käyttäminen",
    "Disconnect my Microsoft account": "Microsoft-tilin yhteyden katkaiseminen",
    "Connect my Microsoft account": "Microsoft-tilin yhdistäminen",
    "Use my google account": "Käytä Google-tiliäni",
    "Connect my google account": "Google-tilin yhdistäminen",
    "Disconnect my google account": "Google-tilin yhteyden katkaiseminen",
    "Use my Xero account": "Use my Xero account",
    "Connect my Xero account": "Connect my Xero account",
    "Disconnect my Xero account": "Disconnect my Xero account",
    "Emails": "Sähköpostiviestit",
    "Daily agenda": "Päiväohjelma",
    "Unread notifications": "Lukemattomat ilmoitukset",
    "Task assigned to me": "Minulle annettu tehtävä",
    "Weekly summary": "Viikon yhteenveto",
    "Monthly summary": "Kuukauden yhteenveto",
    "Updates and tips": "Päivitykset ja vinkit",
    "Overdue": "Myöhässä",
    "1 day": "1 päivä",
    "1 day overdue": "1 päivä myöhässä",
    "{0} days": "{0} päivää",
    "{0} days overdue": "{0} päivää myöhässä",
    "{0} minute ago": "{0} minuutti sitten",
    "{0} minutes ago": "{0} minuuttia sitten",
    "{0} hour ago": "{0} tunti sitten",
    "{0} hours ago": "{0} tuntia sitten",
    "Sunday": "Sunnuntai",
    "Monday": "Maanantai",
    "Tuesday": "Tiistai",
    "Wednesday": "Keskiviikko",
    "Thursday": "Torstai",
    "Friday": "Perjantai",
    "Saturday": "Lauantai",
    "Sun": "Su",
    "Mon": "Ma",
    "Tue": "Ti",
    "Wed": "Ke",
    "Thu": "To",
    "Fri": "Pe",
    "Sat": "La",
    "January": "tammikuu",
    "February": "helmikuu",
    "March": "maaliskuu",
    "April": "huhtikuu",
    "May": "toukokuu",
    "June": "kesäkuu",
    "July": "heinäkuu",
    "August": "elokuu",
    "September": "syyskuu",
    "October": "lokakuu",
    "November": "marraskuu",
    "December": "joulukuu",
    "Jan": "Tammi",
    "Feb": "Helmi",
    "Mar": "Maalis",
    "Apr": "Huhti",
    "Jun": "Kesä",
    "Jul": "Heinä",
    "Aug": "Elo",
    "Sep": "Syys",
    "Oct": "Loka",
    "Nov": "Mar",
    "Dec": "Joulu",
    "Today": "Tänään",
    "Yesterday": "Eilen",
    "Day": "Päivä",
    "Days": "Päivää",
    "+{0} d": "+{0} p",
    "+{0} wd": "+{0} tp",
    "Weekly {0}": "Viikoittainen {0}",
    "Every {0}. week {1}": "Joka {0}. viikko {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Kuukausittainen {0}. d",
    "Every {0}. month {1}. d": "Joka {0}. kuukausi {1}. d",
    "{0}. d": "{0}. pvä",
    "Quarterly {0}. month {1}. d": "Neljännesvuosittainen {0}. kuukausi {1}. d",
    "Every {0}. quarter {1}. month {2}. d": "Joka {0}. Neljännes {1}. kuukausi {2}. d",
    "{0}. month {1}. d": "{0}. kuukauden {1}. pvä",
    "Yearly {0}": "Vuosittaiset {0}",
    "Every {0}. year {1}": "Joka {0}. vuosi {1}",
    "Mo": "ma",
    "Tu": "ti",
    "We": "ke",
    "Th": "to",
    "Fr": "pe",
    "Sa": "la",
    "Su": "su",
    "and": "ja",
    "{0}w": "{0}w",
    "{0}d": "{0}d",
    "before": "ennen",
    "after": "jälkeen",
    "Project": "Projekti",
    "Quarter": "Vuosineljännes",
    "Add logo": "Add logo",
    "Add your photo": "Lisää valokuvasi",
    "Adding file failed": "Tiedoston lisääminen epäonnistui ",
    "Please check the file.": "Tarkista tiedosto.",
    "You can only add pictures.": "Ainoastaan kuvia voi lisätä.",
    "Error": "Virhe",
    "Create new topic": "Luo uusi aihe",
    "Name": "Nimi",
    "Close": "Sulje",
    "Find topic...": "Etsi aihe...",
    "New topic": "Uusi aihe",
    "Invalid format": "Virheellinen muoto",
    "Demo company account": "Demoyrityksen tili",
    "Demo account will be deleted later. Do this for testing purposes only!": "Demotili poistetaan myöhemmin. Tee tämä vain testaustarkoituksiin!",
    "Subscribe": "Tilaa",
    "Start demo": "Aloita demo",
    "End demo": "Lopeta demo",
    "Free trial is expired - {0}": "Ilmainen kokeilu on päättynyt - {0}",
    "Free trial {1} {2} left - {0}": "Ilmainen kokeilu {1} {2} jäljellä - {0}",
    "Add time": "Lisää aika",
    "Billable": "Laskutettava",
    "Date": "Päivämäärä",
    "Start": "Alku",
    "End": "Loppu",
    "Duration": "Kesto",
    "Split duration equally": "Jaa kesto tasaisesti",
    "Required field": "Pakollinen kenttä",
    "Members list": "Jäsenluettelo",
    "Edit fields": "Kenttien muokkaaminen",
    "Maximum number of selected columns has been exceeded": "Valittujen sarakkeiden enimmäismäärä on ylitetty",
    "If you want to add a new column to the report, please remove an existing one first.": "Jos haluat lisätä raporttiin uuden sarakkeen, poista ensin olemassa oleva sarake.",
    "Snooze until...": "Torkku, kunnes...",
    "Select date & time": "Valitse päivämäärä ja aika",
    "Tomorrow": "Huomenna",
    "Later this week": "Myöhemmin tällä viikolla",
    "Next week": "Seuraava viikko",
    "Add task": "Lisää tehtävä",
    "Checklist": "Tarkistuslista",
    "Start timer": "Käynnistä ajastin",
    "Add an item": "Lisää kohde",
    "Add checklist item": "Lisää tarkistuslistan kohde",
    "Convert to a task": "Tehtäväksi muuntaminen",
    "Delete": "Poista",
    "Delegate to...": "Delegoi...",
    "Please select tasks from the same account": "Valitse tehtävät samalta tililtä",
    "Follow": "Seurataan",
    "Expand sidebar": "Laajenna sivupalkki",
    "Nicely done!": "Hienosti tehty!",
    "You've finished all your tasks, take a second to recharge": "Olet suorittanut kaikki tehtäväsi, käytä hetki lataamiseen",
    "Search tasks...": "Hae tehtäviä...",
    "Search": "Hae",
    "select/unselect all": "Valitse/poista valinta kaikki",
    "Add new client": "Lisää uusi asiakas",
    "Account": "Tili",
    "Client name": "Asiakkaan nimi",
    "Select client": "Valitse asiakas",
    "New client": "Uusi asiakas",
    "Must be an integer": "On oltava kokonaisluku",
    "Must be a number": "Täytyy olla numero",
    "Dashboard": "Hallintapaneeli",
    "Calendar": "Kalenteri",
    "Report": "Raportti",
    "Monitoring": "Seuranta",
    "Suppliers": "Toimittajat",
    "Events": "Tapahtumat",
    "Projects": "Projektit",
    "Help": "Tuki",
    "Invite a friend": "Invite a friend",
    "Settings & Apps": "Asetukset ja sovellukset",
    "Profile": "Profiili",
    "Collapse menu": "Kutista valikko",
    "Expand menu": "Laajenna valikko",
    "Are you sure to delete this attachment?": "Oletko varma, että poistat tämän liitteen?",
    "Select": "Valitse",
    "Edit contacts": "Yhteystietojen muokkaaminen",
    "Add member": "Lisää käyttäjä",
    "Add note": "Lisää huomautus",
    "Open": "Open",
    "Reports": "Raportit",
    "Billing notes": "Laskutusta koskevat huomautukset",
    "Pinned notes": "Kiinnitetyt muistiinpanot",
    "Sub-companies": "Alayhtiöt",
    "Contacts": "Yhteystiedot",
    "Event info": "Tapahtuman perustiedot",
    "Project info": "Projektin tiedot",
    "Summary": "Yhteenveto",
    "Task": "Tehtävä",
    "Time": "Aika",
    "Collapse sidebar": "Kutista sivupalkki",
    "Client Overview": "Asiakkaan yleiskatsaus",
    "Event Overview": "Tapahtuman yleiskatsaus",
    "Project Overview": "Projektin yleiskatsaus",
    "Edit client": "Muokkaa asiakasta",
    "Edit event": "Muokkaa tapahtumaa",
    "Edit project": "Muokkaa projektia",
    "Show all": "Näytä kaikki",
    "Collapse": "Tiivistä",
    "by": "tekijä",
    "View all": "Näytä kaikki",
    "Copied to clipboard": "Kopioitu leikepöydälle",
    "Client portal invite sent on {0}": "Client portal invite sent on {0}",
    "Client portal invite has not been sent": "Client portal invite has not been sent",
    "Resend invite": "Ähetä kutsu uudelleen",
    "Send invite": "Lähetä kutsu",
    "Invite sent": "Kutsu lähetetty",
    "Add company event": "Lisää yritystapahtuma",
    "Company": "Yritys",
    "Info": "Tiedot",
    "Holiday": "Lomapäivä",
    "All day(s)": "Koko päivän/päivät",
    "End date": "Päättymispäivä",
    "From": "Alkaen",
    "Until": "Asti",
    "Hours": "Tuntia",
    "Link": "Linkki",
    "Save": "Tallenna",
    "Are you sure that you want to delete this company calendar event?": "Oletko varma, että haluat poistaa tämän yrityksen kalenteritapahtuman?",
    "Location of client folder in your document management system": "Location of client folder in your document management system",
    "Defined main folder": "Defined main folder",
    "Custom folder": "Custom folder",
    "Add new role": "Lisää uusi rooli",
    "New role": "Uusi rooli",
    "Access enabled": "Käyttö käytössä",
    "Waiting for files": "Odotetaan tiedostoja",
    "Uploaded": "Ladattu",
    "Uploading...": "Ladataan...",
    "Client members": "Asiakkaan jäsenet",
    "Email settings": "Sähköpostiasetukset",
    "Or connect new email address": "Voit myös yhdistää uuden sähköpostiosoitteen",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Yhteyden muodostaminen Microsoft Exchangeen tai muuhun sähköpostipalvelimeen (SMTP)",
    "Test email sent": "Testisähköposti lähetetty",
    "Email address": "Sähköpostiosoite",
    "Reply address": "Vastaa osoite",
    "Sender name": "Lähettäjän nimi",
    "Who can use?": "Kuka voi käyttää?",
    "Client default address": "Asiakkaan oletusosoite",
    "Invalid e-mail": "Virheellinen sähköpostiosoite",
    "Role": "Rooli",
    "E-mail": "Sähköpostiosoite",
    "Mobile phone": "Matkapuhelin",
    "Work phone": "Työpuhelin",
    "Language": "Kieli",
    "Birthday": "Syntymäpäivä",
    "Are you sure to delete this contact?": "Oletko varma, että poistat tämän yhteystiedon?",
    "Manage contact fields": "Yhteystietokenttien hallinta",
    "Administrative Assistant": "Hallinnollinen avustaja",
    "Board member": "Hallituksen jäsen",
    "CEO": "Toimitusjohtaja",
    "Add contact": "Lisää yhteystieto",
    "Contact person": "Yhteyshenkilö",
    "Leave page?": "Poistu sivulta?",
    "Changes that you made may not be saved": "Tekemiäsi muutoksia ei ehkä tallenneta",
    "Leave": "Eroa",
    "Validate tasks": "Validate tasks",
    "The Contact you are trying to delete is an assignee in {0} tasks. Remove the contact from tasks to continue.": "The Contact you are trying to delete is an assignee in {0} tasks. Remove the contact from tasks to continue.",
    "Continue": "Jatka",
    "Super! We're importing your clients...": "Super! Tuomme asiakkaasi...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Voit vapaasti poistua tältä sivulta. Annamme ilmoituksen, kun tuonti on valmisteltu. Sitten sinun on vahvistettava asiakkaat, jotka haluat lisätä Ukuun.",
    "Please wait...": "Odota hetki…",
    "Setup API keys": "Määritä API-avaimet",
    "You have two options": "Sinulla on kaksi vaihtoehtoa",
    "how to setup API keys": "API-avainten määrittäminen",
    "Custom import": "Mukautettu tuonti",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "Asiakkaiden ja työmäärän tuominen ! INTEGRAATIO, Uku tarvitsee ! INTEGRATION API -avain jokaiselle asiakkaalle.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=\"font-weight-medium\">Jatka</span> - Uku luo API-avaimet automaattisesti jokaiselle asiakkaalle",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=\"font-weight-medium\">Mukautettu tuonti</span> - Uku muodostaa yhteyden vain olemassa oleviin UKU API -avaimiin. Luo API-avaimet manuaalisesti ! INTEGROINTI ennen tuontia. Lukea:",
    "(it takes a lot of time)": "(se vie paljon aikaa)",
    "Import Clients": "Asiakkaiden tuominen",
    "Country": "Maa",
    "Please choose your country": "Valitse maasi",
    "Password": "Salasana",
    "Start import": "Aloita tuonti",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Insertti! INTEGRAATIO-kirjautumistiedot (se on suojattu), jotta voit käyttää tuontiasiakkaita ja API-avaimia kerran. Huomaa, että sinut kirjataan ulos ! INTEGROINTI muihin selaimiin.",
    "Update invoice status": "Päivitä laskun tila",
    "Update now": "Päivitä nyt",
    "Daily @ 14:00": "Päivittäin @ 14:00",
    "Daily @ 18:00": "Päivittäin @ 18:00",
    "Updating invoice statuses, please wait...": "Laskujen tilojen päivittäminen, odota...",
    "Your import is ready": "Tuonti on valmis",
    "In the final step you need to confirm the clients you want to add to uku": "Viimeisessä vaiheessa sinun on vahvistettava asiakkaat, jotka haluat lisätä ukuun",
    "Let's go": "Aloita",
    "Import again": "Tuo uudelleen",
    "Do you have new clients to import?": "Onko sinulla uusia asiakkaita tuotavaksi?",
    "Yes, i do": "Kylläpä vain",
    "View last import": "Näytä viimeisin tuonti",
    "Email server": "Sähköpostipalvelin",
    "Email provider": "Sposti palveluntarjoajalle",
    "Host": "Isäntä",
    "Port": "Portti",
    "Security": "Turvallisuus",
    "Sender email": "Lähettäjän osoite",
    "Username": "Käyttäjätunnus",
    "Test connection": "Testiliitäntä",
    "How to set up": "Määrittäminen",
    "Only administrators can activate the app": "Vain järjestelmänvalvojat voivat aktivoida sovelluksen",
    "You are in the waiting list": "Olet odotuslistalla",
    "We onboard all applicants one by one": "Perehdytämme kaikki hakijat yksitellen",
    "Connected": "Yhdistetty",
    "Activated": "Aktivoitu",
    "Join waiting list": "Liity jonotuslistalle",
    "Activate": "Aktivoi",
    "Unsubscribe from waiting list": "Peruuta odotuslistan tilaus",
    "Deactivate app": "Poista sovellus käytöstä",
    "Disconnect": "Katkaise yhteys",
    "Hide expanded content": "Hide expanded content",
    "Show trimmed content": "Show trimmed content",
    "Email not delivered": "Sähköpostia ei toimitettu",
    "Sent, but fallback to Uku email": "Lähetetty, mutta varalla Uku-sähköpostiin",
    "Unknown error": "Tuntematon virhe",
    "to": "-",
    "automatically": "automatically",
    "in any minute": "minä hetkenä hyvänsä",
    "on {0},": "{0},",
    "or": "tai",
    "Send now": "Lähetä nyt",
    "Uku will no longer send email": "Uku will no longer send email",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku <span class='subtitle-2'>lähettää sähköpostia</span>",
    "__From_email": "__From_email",
    "Set up email": "Sähköpostin määrittäminen",
    "Client default": "Asiakkaan oletusasetus",
    "Subject": "Aihe",
    "Edit email": "Muokkaa sähköpostia",
    "Template": "Mallipohja",
    "Cc": "Kopio",
    "Bcc": "Viestin piilokopio",
    "__To_email": "__To_email",
    "__Cc_email": "__Cc_email",
    "__Bcc_email": "__Bcc_email",
    "Add template": "Lisää malline",
    "Add automation": "Lisää automaatio",
    "Add placeholder": "Paikkamerkin lisääminen",
    "Format text": "Tekstin muotoilu",
    "Add attachment": "Lisää liitetiedosto",
    "Send": "Lähetä",
    "Save automation": "Säästä automaatiota",
    "Choose email template": "Valitse sähköpostimalli",
    "All languages": "Kaikki kielet",
    "No templates found.": "Malleja ei löytynyt.",
    "Edit email template": "Muokkaa sähköpostimallia",
    "Are you sure you want to delete this template? Some tasks will be affected": "Haluatko varmasti poistaa tämän mallin? Tämä vaikuttaa joihinkin tehtäviin",
    "Are you sure you want to delete this template?": "Haluatko varmasti poistaa tämän mallin?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Haluatko varmasti tallentaa tämän mallin, se vaikuttaa seuraaviin tehtäviin?",
    "Template name": "Mallipohjan nimi",
    "Edit template": "Muokkaa mallia",
    "Send email": "Lähetä sähköpostia",
    "on": "päällä",
    "Ok": "Ok",
    "Supplier": "Toimittaja",
    "Event": "Tapahtuma",
    "Contact": "Ota yhteyttä",
    "Validation failed": "Vahvistus epäonnistui",
    "Saving supplier failed": "Toimittajan tallentaminen epäonnistui",
    "Saving client failed": "Asiakkaan tallentaminen epäonnistui",
    "Saving project failed": "Projektin tallentaminen epäonnistui",
    "several values": "useita arvoja",
    "values": "arvot",
    "is": "on",
    "Add filter": "Lisää suodatin",
    "Update": "Päivitä",
    "forever": "ikuisesti",
    "Last week": "Edellinen viikko",
    "This week": "Tämä viikko",
    "Last month": "Edellinen kuukausi",
    "This month": "Tämä kuukausi",
    "Next month": "Seuraava kuukausi",
    "Last year": "Edellinen vuosi",
    "This year": "Tänä vuonna",
    "This quarter": "tällä vuosineljänneksellä",
    "Next quarter": "Seuraava vuosineljännes",
    "Last quarter": "Viimeinen neljännes",
    "Client group": "Asiakasryhmä",
    "Topic": "Aihe",
    "Member": "Jäsen",
    "Primary member": "Ensisijainen jäsen",
    "Client status": "Asiakkaan tila",
    "Active clients": "Aktiiviset asiakkaat",
    "Inactive clients": "Ei-aktiiviset asiakkaat",
    "All": "Kaikki",
    "Project status": "Projektin tila",
    "Member status": "Jäsenen asema",
    "Active members": "Aktiiviset jäsenet",
    "Limited members": "Rajoitetut jäsenet",
    "Inactive members": "Ei-aktiiviset jäsenet",
    "Contract status": "Sopimuksen tila",
    "Active contracts": "Aktiiviset sopimukset",
    "Pending contracts": "Vireillä olevat sopimukset",
    "Finished contracts": "Päättyneet urakat",
    "Contract template": "Sopimuspohja",
    "Payment recurrence": "Maksun toistuminen",
    "Yearly": "Vuosittain",
    "Monthly": "Kuukausittain",
    "Trial": "Kokeilujakso",
    "Region": "Alue",
    "Field": "Kenttä",
    "All tasks": "Kaikki tehtävät",
    "Todo": "Tehtävä",
    "Not done": "Ei valmis",
    "Done": "Valmis",
    "Delayed": "Viivästynyt",
    "Important": "Tärkeä",
    "Extra work": "Lisätyötä",
    "I Follow": "Seuraan",
    "Commented": "Kommentoitu",
    "Tracked time": "Seurattu aika",
    "Estimated": "Arvioitu",
    "Recurring task": "Toistuva tehtävä",
    "Last import": "Viimeisin tuonti",
    "Period": "Jakso",
    "Client search": "Asiakkaan haku",
    "Voucher": "Koodi",
    "Company status": "Yrityksen asema",
    "Deleted": "Poistettu",
    "All status": "Kaikki tilat",
    "Payment gateway": "Maksun yhdyskäytävä",
    "All gateways": "Kaikki yhdyskäytävät",
    "Uku manually": "Uku manuaalisesti",
    "Braintree": "Braintree",
    "Plan status": "Suunnitelman tila",
    "All plans": "Kaikki jäsenyysohjelmat",
    "Paid": "Maksettu",
    "Paid churn": "Maksettu vaihtuvuus",
    "Trial churn": "Oikeudenkäynnin vaihtuvuus",
    "Plan period": "Suunnitelman kesto",
    "All periods": "Kaikki jaksot",
    "Monthly plan": "Kuukausittainen suunnitelma",
    "Yearly plan": "Vuosittainen suunnitelma",
    "Company search": "Yrityksen haku",
    "User search": "Käyttäjän haku",
    "Name key search": "Nimiavaimen haku",
    "None filter": "Ei mitään suodatinta",
    "OK": "Ok",
    "Start date cannot be later than due date": "Alkamispäivä ei voi olla myöhäisempi kuin eräpäivä",
    "tasks": "tehtävät",
    "task(s) had errors": "Tehtävissä oli virheitä",
    "tasks selected": "Valitut tehtävät",
    "Postpone": "Lykkää myöhemmäksi",
    "Mark done": "Merkitse valmiiksi",
    "Hide multiselect": "Piilota monivalinta",
    "Delete task(s)": "Poista tehtävät",
    "All of the data related to the task will be deleted": "Kaikki tehtävään liittyvät tiedot poistetaan",
    "Some tasks include other people. Are you sure you want to delete?": "Joissakin tehtävissä on muita ihmisiä. Haluatko varmasti poistaa?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Joidenkin valittujen toimintojen aikaa on seurattu. Haluatko varmasti poistaa?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Joidenkin valittujen toimintojen aikaa on seurattu. Joissakin tehtävissä on muita ihmisiä. Haluatko varmasti poistaa?",
    "task(s) were not marked done": "Tehtäviä ei merkitty tehdyiksi",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Tarkista, onko tarkistuslista täytetty tai onko aika syötetty ja ne on annettu sinulle",
    "task(s) were not deleted": "Tehtäviä ei poistettu",
    "task(s) time was not updated": "Tehtävien aikaa ei päivitetty",
    "Please make sure that you can add time to task": "Varmista, että voit lisätä aikaa tehtävään",
    "invoice table row": "Laskutaulukon rivi",
    "invoice table row(s) had errors": "Laskutaulukon riveillä oli virheitä",
    "invoice table row(s) selected": "Laskutaulukon rivi(t) valittu",
    "Create": "Luo",
    "Mark paid": "Merkitse maksetuksi",
    "Send to client": "Lähetä asiakkaalle",
    "Recalculate": "Laske uudelleen",
    "Export to {0}": "Vienti {0}",
    "Update Status from {0}": "Päivitä tila {0}",
    "Void invoice": "Mitätön lasku",
    "Delete invoice": "Poista lasku",
    "Restore invoice": "Palauta lasku",
    "Mark unpaid": "Merkitse maksamatta",
    "Invoices": "Laskut",
    "Download to Excel": "Lataa Exceliin",
    "Revenue split": "Tulojen jakautuminen",
    "Tax": "Vero",
    "Description": "Kuvaus",
    "Percent": "Prosentti",
    "Integration Id": "Integroinnin tunnus",
    "Integration Code": "Integraation koodi",
    "Name on invoice": "Nimi laskussa",
    "Restore": "Palauta",
    "Archive": "Arkisto",
    "Hide": "Piilota",
    "Are you sure?": "Oletko varma?",
    "Invoice seller": "Invoice seller",
    "Company name": "Yrityksen nimi",
    "Address": "Osoite",
    "Company number": "Y-tunnus",
    "Tax number": "Tax number",
    "Bank": "Bank",
    "IBAN": "IBAN",
    "Delete logo": "Poista logo",
    "Upload logo file": "Lataa logotiedosto",
    "Max. dimensions 130 x 130 px": "Max. dimensions 130 x 130 px",
    "Import finished!": "Tuonti valmis!",
    "Failed to import {0} records": "{0}tietueiden tuonti epäonnistui",
    "Download report": "Lataa raportti",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Tulos: lisätty {0}, päivitetty {1}, ohitettu {2}, {3} tuonti epäonnistui",
    "Result: added {0}, updated {1}, skipped {2}": "Tulos: lisätty {0}, päivitetty {1}, ohitettu {2}",
    "What’s next?": "Mitä seuraavaksi?",
    "To work effectively with your client base, complete the following steps:": "Voit työskennellä tehokkaasti asiakaskuntasi kanssa seuraavasti:",
    "Read more ›": "Lue lisää ›",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Seuraavaksi näet vain aktiiviset tuodut asiakkaat. Jos haluat nähdä kaikki asiakkaat, poista Viimeisin tuonti -suodatin.",
    "View clients": "Näytä asiakkaat",
    "Add <b>primary member</b> to every client.": "Lisää <b>ensisijainen jäsen</b> jokaiseen asiakkaaseen.",
    "Add <b>task plan</b> to automate recurring tasks.": "Lisää <b>tehtäväsuunnitelma</b> toistuvien tehtävien automatisoimiseksi.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Määritä automaattinen kuukausiyhteenveto {0}sovelluksessa Ukussa tuodaksesi työmäärän.",
    "Title": "Otsikko",
    "Field type": "Kenttätyyppi",
    "Field name": "Kentän nimi",
    "Client section": "Client section",
    "Choices": "Valintoja",
    "Type each choice on a separate line": "Kirjoita kukin vaihtoehto erilliselle riville",
    "Required": "Pakollinen",
    "For all topics": "Kaikille aiheille",
    "For specific topics": "Tietyt aiheet",
    "Topics": "Aiheet",
    "Non-billable": "Ei-laskutettava",
    "Edit task custom field": "Muokkaa tehtävän mukautettua kenttää",
    "Add task custom field": "Lisää tehtävän mukautettu kenttä",
    "Edit client custom field": "Muokkaa asiakkaan mukautettua kenttää",
    "Add client custom field": "Lisää asiakkaan mukautettu kenttä",
    "Choice {0}": "Valinta {0}",
    "Are you sure that you want to delete this custom field?": "Oletko varma, että haluat poistaa tämän lisäkentän?",
    "Warning!": "Varoitus!",
    "This custom field is in use. Do you wish to archive it?": "Tämä mukautettu kenttä on käytössä. Haluatko arkistoida sen?",
    "Reconnect": "Yhdistä uudelleen",
    "Send test email": "Lähetä testisähköpostia",
    "Email address or username": "Sähköpostiosoite tai käyttäjänimi",
    "Other": "Muu",
    "Set default email server for company": "Aseta yrityksen oletussähköpostipalvelin",
    "My default email": "Oletussähköpostiosoitteeni",
    "Depends on": "Riippuu",
    "Todo - Blocking": "Todo - Estäminen",
    "In progress - Blocking": "Käynnissä - Estäminen",
    "In progress": "Kesken",
    "Client code": "Asiakkaan koodi",
    "Primary user": "Ensisijainen käyttäjä",
    "Added date": "Lisätty päivämäärä",
    "Updated": "Päivitetty",
    "Contract count": "Sopimusten määrä",
    "Integration": "Integrointi",
    "No data available": "Tietoja ei löytynyt",
    "No results found": "Hakutuloksia ei löytynyt",
    "Loading": "Ladataan",
    "Sort by": "Lajitteluperuste",
    "{0}-{1} of {2}": "{0}-{1} {2}",
    "Rows per page": "Riviä sivulla",
    "Ongoing": "Menossa",
    "important": "tärkeä",
    "Read more": "Lue lisää",
    "Add to previous time entry": "Lisää edelliseen aikamerkintään",
    "Add to next time entry": "Lisää seuraavan kerran merkintään",
    "Add new task": "Lisää uusi tehtävä",
    "Cut previous time entry": "Leikkaa edellinen aikamerkintä",
    "Cut next time entry": "Leikkaa seuraavalla kerralla",
    "Missing time entry": "Puuttuva aikamerkintä",
    "Overlapping time entries": "Päällekkäiset aikamerkinnät",
    "Member from custom fields": "Jäsen mukautetuista kentistä",
    "Delegated to": "Delegoitu",
    "Delegated by": "Delegoinut",
    "Visible members": "Näkyvät jäsenet",
    "Member type": "Jäsentyyppi",
    "Groups": "Ryhmät",
    "Custom field": "Mukautetut kentät",
    "Contact search": "Yhteystietohaku",
    "Task start": "Tehtävän aloitus",
    "Task due": "Tehtävä erääntyy",
    "Task finish": "Tehtävän loppu",
    "Custom date": "Mukautettu päivämäärä",
    "Never": "Ei koskaan",
    "Referral status": "Referral status",
    "Invited": "Kutsuttu",
    "Registered": "Registered",
    "Earned": "Earned",
    "Agreed work is still expected": "Sovittua työtä odotetaan edelleen",
    "Accepted flextime": "Hyväksytty liukuva työaika",
    "Declined flextime": "Hylätty joustava työaika",
    "Cancelled flextime": "Peruutettu liukuva työaika",
    "Updated flextime": "Päivitetty liukuva työaika",
    "Calendar deleted": "Kalenteri poistettu",
    "Calendar created": "Kalenteri luotu",
    "Calendar approved": "Kalenteri hyväksytty",
    "Calendar declined": "Kalenteri hylätty",
    "Calendar updated": "Kalenteri päivitetty",
    "Flextime balance updated": "Liukuvan työajan saldo päivitetty",
    "Flextime": "Liukuva työaika",
    "Vacation": "Loma",
    "Balance": "Saldo",
    "Comment": "Kommentti",
    "History": "Historia",
    "Action": "Toiminto",
    "Who": "Kuka",
    "Take a vacation or mark an absence": "Ota loma tai merkitse poissaolo",
    "Away": "Poissa",
    "Flextime bonus": "Liukuvan työajan bonus",
    "Approver": "Hyväksyjä",
    "Vacation available": "Loma saatavilla",
    "Type": "Tyyppi",
    "Reduce agreed working hours": "Lyhennä sovittua työaikaa",
    "Reject": "Hylkää",
    "Approve": "Hyväksy",
    "away_type_Away": "away_type_Away",
    "Sick leave": "Sairasloma",
    "Parental leave": "Vanhempainloma",
    "Working hours": "Working hours",
    "Mon-Fri, 40h weekly, 8h daily": "Mon-Fri, 40h weekly, 8h daily",
    "Customize": "Customize",
    "Total": "Yhteensä",
    "Settings": "Asetukset ",
    "Work on holidays": "Työskentele lomilla",
    "Get {0} in cash for every referral who becomes a Uku client.": "Get {0} in cash for every referral who becomes a Uku client.",
    "Copy your invite link": "Copy your invite link",
    "Hide message": "Hide message",
    "View message": "View message",
    "Your statistics": "Your statistics",
    "Copy message": "Copy message",
    "How it works": "How it works",
    "Invite your friends to Uku, and we'll give a free month of Uku - and show them how to boost their business.": "Invite your friends to Uku, and we'll give a free month of Uku - and show them how to boost their business.",
    "After your referral becomes a paying Uku client, we send you a {0} gift card.": "After your referral becomes a paying Uku client, we send you a {0} gift card.",
    "More ways to earn cash": "More ways to earn cash",
    "referral_email_content": "referral_email_content",
    "Write feedback for Uku and get <a href='/api/help_link/referral_feedback' target='_blank'>{0} gift card here</a>": "Write feedback for Uku and get <a href='/api/help_link/referral_feedback' target='_blank'>{0} gift card here</a>",
    "Expand": "Laajenna",
    "Wait until event status": "Odota tapahtuman tilaa",
    "Wait until project status": "Odota projektin tilaa",
    "Week(s)": "Viikko(a)",
    "Day(s)": "Päivä(ä)",
    "Rule": "Sääntö",
    "Depends on event": "Riippuu tapahtumasta",
    "Depends on project": "Riippuu projektista",
    "Due date in": "Eräpäivä vuonna",
    "Status": "Tila",
    "Select event": "Valitse koulutus",
    "Select project": "Valitse projekti",
    "Find event...": "Etsi tapahtuma...",
    "Find project...": "Etsi projekti...",
    "Custom recurrence": "Mukautettu toistuvuus",
    "Every": "Joka",
    "In case of holiday": "Jos kyseessä on loma",
    "Set time": "Aseta aika",
    "Start time": "Aloitusaika",
    "Repeat from": "Toista kohteesta",
    "Previous repeat from: {0}": "Edellinen toisto: {0}",
    "On date": "Päivämäärä",
    "Plus days": "Plus päivät",
    "Due date time": "Eräpäivä, aika",
    "Remove recurrence": "Poista toistuminen",
    "Repeat": "Toista",
    "month": "kuukausi",
    "quarter": "neljännes",
    "year": "vuosi",
    "1st month": "1. kuukausi",
    "2nd month": "2. kuukausi",
    "3rd month": "3. kuukausi",
    "Day {0}": "Päivä {0}",
    "Show before": "Näytä ennen",
    "Keep the day": "Pidä päivä",
    "Show after": "Näytä jälkeen",
    "From start date": "Aloituspäivästä alkaen",
    "From beginning of the month": "Kuukauden alusta alkaen",
    "All days (Mon to Sun)": "Kaikki päivät (ma-su)",
    "Mon to Fri (incl. holidays)": "ma-pe (sis. pyhäpäivät)",
    "Mon to Fri (excl. holidays)": "ma-pe (pl. juhlapyhät)",
    "1st": "Ensimmäinen",
    "2nd": "Toinen",
    "3rd": "Kolmas",
    "Does not repeat": "Ei toistu",
    "Daily": "Päivittäin",
    "Weekly on {0}": "Viikoittain {0}",
    "Monthly on day {0}": "Kuukausittain {0} päivänä",
    "Quarterly on {0} month {1} day": "Neljännesvuosittain {0} kuukausi {1} päivä",
    "Yearly on {0} {1}": "Vuosittain {0} {1}",
    "Custom...": "Mukautettu…",
    "Incorrect time": "Väärä aika",
    "Add repeat": "Lisää toisto",
    "Email added to queue": "Sähköposti lisätty jonoon",
    "Communication timeline": "Viestinnän aikajana",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Aktivoi sähköpostisovellus App Storessa lähettääksesi automaattisia sähköposteja ja tarkastellaksesi mennyttä ja tulevaa viestintääsi yhdessä paikassa.",
    "Go to App Store": "Siirry App Storeen",
    "Unknown": "Tuntematon",
    "<b>Email</b> from": "<b>Sähköposti</b> lähettäjältä",
    "To": "Vastaanottaja",
    "Planned": "Suunniteltu",
    "Automated emails scheduled to be sent in the future": "Automaattiset sähköpostit, jotka on tarkoitus lähettää tulevaisuudessa",
    "Send e-mail": "Lähetä sähköpostia",
    "Template unlinked": "Mallin linkitys poistettu",
    "Icon": "Kuvake",
    "Link name": "Link name",
    "Link URL": "Link URL",
    "Open in new tab": "Open in new tab",
    "Visible": "Näkyvissä",
    "External": "External",
    "Not external": "Not external",
    "Company default": "Yrityksen maksukyvyttömyys",
    "Not visible": "Not visible",
    "Use company default": "Use company default",
    "or choose icon": "or choose icon",
    "Find member...": "Etsi jäsen...",
    "I'll take it": "Otan sen",
    "Remove me": "Poista minut",
    "Remove from task": "Poista tehtävästä",
    "Learn more": "Lue lisää",
    "Company settings edit is disabled by owner": "Omistaja on poistanut yrityksen asetusten muokkauksen käytöstä",
    "<b>Exported</b> {0} to {1}": "<b>Viedä</b> {0} jotta {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Sent to client</b> {0} from {1}",
    "<b>Paid {0}</b> {1}": "<b>Maksettu {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Kumosi</b> {0}",
    "Do you wish to mark the task done for everyone?": "Haluatko merkitä tehtävän tehdyksi kaikille?",
    "No, remove me": "Ei, poista minut",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Tehtävää ei merkitä valmiiksi, mutta käyttäjä poistetaan vastuuhenkilöistä ja lisätään tehtävän seuraajiin",
    "Invalid email": "Virheellinen sähköpostiosoite",
    "Accounting": "Kirjanpito",
    "General": "Yleinen",
    "Advertising / Marketing/ PR": "Mainos / Markkinointi / PR",
    "Architecture": "Arkkitehtuuri",
    "Construction": "Rakentaminen ",
    "Consulting - IT, software": "Konsultointi - IT, ohjelmistot",
    "Consulting - Management": "Konsultointi - Johtaminen",
    "Finance": "Rahoituspalvelut",
    "Legal": "Juridiikka",
    "Medicine / Pharmacy ": "Lääketiede / Farmasia",
    "Non-profit": "Voittoa tavoittelematon",
    "Web design": "Verkkosivujen suunnittelu",
    "Web development": "Verkkosivujen kehittäminen",
    "Max 140 characters": "Enintään 140 merkkiä",
    "Please complete the checklist": "Ole hyvä ja täytä tarkistuslista",
    "It is required to mark all checklist items as done": "Kaikki tarkistuslistan kohdat on merkittävä tehdyiksi",
    "Please enter time spent": "Ole hyvä ja syötä käytetty aika",
    "Inserting time is essential for this client": "Ajan lisääminen on välttämätöntä tälle asiakkaalle",
    "Only me": "Vain minä",
    "Private": "Yksityinen",
    "Edit note": "Muokkaa huomautusta",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Lisää lisätietoja asiakkaasta, kuten erikoissopimukset, salasanat jne.",
    "Edit": "Muokkaa",
    "Workdays": "Työpäivät",
    "Workhours": "Työaika",
    "Weeks": "Viikkoa",
    "Clear filters": "Tyhjennä suodattimet",
    "Save filters": "Tallenna suodattimet",
    "Expected": "Odotettavissa",
    "Estimation": "Estimointi",
    "Do you also want to postpone the due date?": "Haluatko myös siirtää eräpäivää?",
    "{0} week": "{0} viikko",
    "{0} weeks": "{0} viikkoa",
    "Vacations": "Lomat",
    "Holidays": "Lomapäivät",
    "Tax dates": "Veron päivämäärät",
    "Accounting news": "Kirjanpidon uutiset",
    "Company events": "Yritystapahtumat",
    "Member birthdays": "Jäsenten syntymäpäivät",
    "Contact birthdays": "Ota yhteyttä syntymäpäiviin",
    "Group items": "Ryhmittele kohteet",
    "Don't group": "Älä ryhmittele",
    "{0} away": "{0} poissa",
    "Member birthday | Member birthdays": "Jäsenen syntymäpäivä | Jäsenten syntymäpäivät",
    "Contact birthday | Contact birthdays": "Ota yhteyttä syntymäpäivään | Ota yhteyttä syntymäpäiviin",
    "Contact birthday": "Ota yhteyttä syntymäpäivään",
    "Member birthday": "Jäsenen syntymäpäivä",
    "Are you sure you wish to delete this link?": "Haluatko varmasti poistaa tämän linkin?",
    "Reference name": "Viitteen nimi",
    "Reference link": "Viite linkki",
    "Free trial": "Ilmainen kokeilu",
    "Solo": "Soolo",
    "Team": "Tiimi",
    "Enterprise": "Enterprise",
    "Mini Uku": "Mini Uku",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Chrome-selaimen laajennus Ukulle hallitaksesi tehtävääsi, asiakkaitasi ja seurataksesi aikaa.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Määritä tehtävä-/työsuunnitelmia automatisoidaksesi työnkulkusi, lisätäksesi aiheita, mukautettuja kenttiä ja muokataksesi asetuksiasi.",
    "Setup client groups, custom fields and modify your preferences.": "Määritä asiakasryhmiä, mukautettuja kenttiä ja muokkaa asetuksiasi.",
    "test": "testi",
    "Anti Money Laundering": "Rahanpesun torjunta",
    "Setup your customer AML and get instant reminders when auditing is due.": "Määritä asiakkaasi AML ja saat välittömiä muistutuksia, kun auditointi on määräpäivä.",
    "flextime_description": "flextime_description",
    "Smart Accounts": "Älykkäät tilit",
    "Automatically imports work statistics from your accounting software.": "Tuo työtilastot automaattisesti kirjanpito-ohjelmistostasi.",
    "Merit Aktiva": "Merit Aktiva",
    "360 Księgowość": "360 Księgowość",
    "Speed up your client billing process with pricelists and smart contracts.": "Nopeuta asiakaslaskutusprosessia hinnastojen ja älykkäiden sopimusten avulla.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Visuaalinen raportti kertoo tarkalleen, kuinka kannattava tai kannattamaton asiakkaasi on.",
    "Emailing description": "Sähköpostin kuvaus",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Synkronoi asiakastiedot Ukusta e-conomiciin ja päinvastoin. Tarkastele kunkin asiakkaan myyntitapahtumia.",
    "Xero": "Xero",
    "xero_description": "xero_description",
    "QuickBooks": "QuickBooks",
    "quickbooks_description": "quickbooks_description",
    "Tripletex": "Tripletex",
    "tripletex_description": "tripletex_description",
    "Scoro": "Scoro",
    "Export sales invoices.": "Vie myyntilaskut.",
    "Fortnox": "Fortnox",
    "fortnox_description": "fortnox_description",
    "Magic button": "Maaginen painike",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Yhdellä napsautuksella - nopea ja helppo tapa luoda tärkeitä tehtäviä. Esimerkiksi puhelu asiakkaalta.",
    "With suppliers, you make your projects and partners management more efficient.": "Toimittajien kanssa tehostat projektien ja kumppaneiden hallintaa.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Tehokas ja joustava projektinhallinta palvelee erilaisia käyttötapauksia ja työnkulkuja.",
    "client_portal_app_description": "client_portal_app_description",
    "Chat": "Chat",
    "chat_app_description": "chat_app_description",
    "Companies House": "Yritysten talo",
    "companies_house_app_description": "companies_house_app_description",
    "documents_app_description": "documents_app_description",
    "FreeAgent": "FreeAgent",
    "freeagent_description": "freeagent_description",
    "Trigon": "Trigon",
    "trigon_description": "trigon_description",
    "Connect and discover tools to help you manage your business.": "Yhdistä ja löydä työkaluja, joiden avulla voit hallita liiketoimintaasi.",
    "Subscribe now": "Tilaa nyt",
    "Compare plans": "Vertaile palvelupaketteja",
    "Add company": "Lisää yritys",
    "BETA": "BETA",
    "Setup": "Asetukset",
    "Power up": "Virta päälle",
    "Integrations": "Integraatiot",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Moikka! Haluatko työskennellä tiimin kanssa ja käyttää lisäominaisuuksia? Ei hätää, lisää ensin yrityksesi!",
    "Read more about Uku plans": "Lue lisää Uku-suunnitelmista",
    "Contact role": "Yhteyshenkilön rooli",
    "Contact roles": "Yhteyshenkilön roolit",
    "Client groups": "Asiakasryhmät",
    "Client fields": "Asiakas-kentät",
    "Contact fields": "Yhteyshenkilö-kentät",
    "View archive": "Näytä arkisto",
    "Restore from archive": "Palauta arkistosta",
    "Empty list": "Tyhjä luettelo",
    "Task fields": "Tehtävä-kentät",
    "task topics": "Tehtävien aiheet",
    "Keep the task opened when starting the timer": "Pidä tehtävä auki, kun käynnistät ajastimen",
    "task templates": "Tehtävämallit",
    "Author": "Tekijä",
    "Duplicate": "Monista",
    "Uku task templates": "Uku-tehtäväpohjat",
    "Are you sure that you want to delete this task template?": "Haluatko varmasti poistaa tämän tehtävämallin?",
    "Templates": "Mallit",
    "Overview": "Yhteenveto",
    "chat_app_overview_text": "chat_app_overview_text",
    "Color": "Väri",
    "Are you sure to delete this field? You may lose the data.": "Oletko varma, että poistat tämän kentän? Saatat menettää tiedot.",
    "Add field": "Lisää kenttä",
    "Add section": "Lisää osio",
    "multiline": "Monirivinen",
    "Import": "Tuo",
    "Import data": "Tietojen tuonti",
    "Automate data collection with Smart Accounts": "Automatisoi tiedonkeruu älykkäiden tilien avulla",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Tuo osto- ja myyntitapahtumat, tapahtumien kokonaismäärä ja syöttörivien määrä;</li><li>Automatisoi tiedonkeruu älykkäiden tilien avulla;</li><li>Nopeampi ja tarkempi laskutus automaattisen tiedonvaihdon avulla. Uku kerää yhteen paikkaan tietoa asiakkaiden laskujen laatimista varten ja tehostaa laskutusta.</li></ul>",
    "xero_app_overview_text": "xero_app_overview_text",
    "Import clients from {0}": "Asiakkaiden tuominen {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Ennen asiakkaiden tuomista sinun on valtuutettava Xero ja valittava yritys.",
    "Authorize Xero to start import": "Valtuuta Xero aloittamaan tuonti",
    "Failed to import clients": "Asiakkaiden tuonti epäonnistui",
    "Failed to connect to WS": "WS-yhteyden muodostaminen epäonnistui",
    "emailing_app_overview_text": "emailing_app_overview_text",
    "Email signatures": "Email signatures",
    "Everyone": "Kaikki",
    "Access": "Pääsy",
    "Creator": "Tekijä",
    "Are you sure you want to delete this signature? Some emails will be affected": "Are you sure you want to delete this signature? Some emails will be affected",
    "Email addresses": "Sähköpostiosoitteet",
    "Signatures": "Signatures",
    "Send emails": "Send emails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku integroituu turvallisesti sähköpostiisi, mikä auttaa sinua hallitsemaan ja automatisoimaan viestintää",
    "Use {0} address": "Käytä {0} osoitetta",
    "connect your email address": "Yhdistä sähköpostiosoitteesi",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Yhteyden muodostaminen Microsoft Exchangeen tai muuhun sähköpostipalvelimeen (SMTP)",
    "Email integration reconnected": "Sähköpostin integrointi yhdistetty uudelleen",
    "Are you sure you want to delete this email integration?": "Haluatko varmasti poistaa tämän sähköpostiintegraation?",
    "Email templates": "Sähköpostien pohjat",
    "Add email template": "Lisää sähköpostimalli",
    "Are you sure you want to save this template? Some tasks will be affected": "Haluatko varmasti tallentaa tämän mallin? Tämä vaikuttaa joihinkin tehtäviin",
    "Clients can leave task messages by replying to client portal email": "Clients can leave task messages by replying to client portal email",
    "Send a copy of client's response to member's inbox": "Send a copy of client's response to member's inbox",
    "Email recipients can leave task comments by replying to a task email": "Email recipients can leave task comments by replying to a task email",
    "economic_app_overview_text": "economic_app_overview_text",
    "Default layout": "Oletusasettelu",
    "Change agreement ID": "Sopimustunnuksen muuttaminen",
    "Failed to connect to server": "Yhteyden muodostaminen palvelimeen epäonnistui",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "Uku tuo kaikki asiakkaat, asiakastiedot ja luokittelijat. Viimeisessä vaiheessa voit valita, mitkä asiakkaat haluat lisätä tai päivittää.",
    "Connect e-conomic": "Yhdistä e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Ennen asiakkaiden tuontia sinun on liitettävä Uku ja taloudellinen ohjelmisto. Voit tehdä tämän luomalla taloudellisen sopimuksen ja antamalla sopimustunnuksen tähän.",
    "Step {0}": "Vaihe {0}",
    "Get agreement ID": "Hanki sopimustunnus",
    "Insert agreement ID": "Sopimustunnuksen lisääminen",
    "Connect": "Yhdistä",
    "quickbooks_app_overview_text": "quickbooks_app_overview_text",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku tuo kaikki asiakkaat, asiakastiedot ja luokittelijat QuickBooksista. Viimeisessä vaiheessa voit valita, mitkä asiakkaat haluat lisätä tai päivittää.",
    "Before importing clients, you need to connect with QuickBooks.": "Ennen kuin tuot asiakkaita, sinun on muodostettava yhteys QuickBooksiin.",
    "Connected to QuickBooks": "Yhdistetty QuickBooksiin",
    "fortnox_app_overview_text": "fortnox_app_overview_text",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku tuo kaikki asiakkaat, asiakastiedot ja luokittelijat Fortnoxista. Viimeisessä vaiheessa voit valita, mitkä asiakkaat haluat lisätä tai päivittää.",
    "Before importing clients, you need to connect with Fortnox.": "Ennen asiakkaiden tuomista sinun on muodostettava yhteys Fortnoxiin.",
    "Connect to Fortnox": "Yhdistä Fortnoxiin",
    "Connected to Fortnox": "Yhdistetty Fortnoxiin",
    "Delete template": "Poista mallipohja",
    "Public": "Julkinen",
    "Workflow templates": "Työnkulun mallit",
    "No workflow templates yet": "Ei vielä työnkulkumalleja",
    "Modified": "Muokattu",
    "Uku workflow templates": "Uku-työnkulkumallit",
    "Are you sure you wish to delete this workflow?": "Haluatko varmasti poistaa tämän työnkulun?",
    "Project fields": "Projekti-kentät",
    "Progress step": "Edistymisvaihe",
    "Rename project": "Nimeä projekti uudelleen",
    "Project statuses": "Projektin tilat",
    "You can use the statuses to restrict the workflow.": "Voit rajoittaa työnkulkua tilojen avulla.",
    "Project phases": "Projektin vaiheet",
    "Make your progress beautiful.": "Tee edistymisestäsi kaunista.",
    "Permissions": "Oikeudet",
    "Users can manage workflow templates": "Käyttäjät voivat hallita työnkulkumalleja",
    "project_app_overview_text": "project_app_overview_text",
    "project_app_overview_description": "project_app_overview_description",
    "Configure summary task": "Määritä yhteenvetotehtävä",
    "Uku will generate task with following title and topic on the last day of the month.": "Uku luo seuraavan otsikon ja aiheen sisältävän tehtävän kuukauden viimeisenä päivänä.",
    "Task title": "Tehtävän otsikko",
    "Recurrence": "Toistuminen",
    "First import start date": "First import start date",
    "Count changes from previous periods": "Edellisiin kausiin verrattuna tehtyjen muutosten laskeminen",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Jos tämä asetus on käytössä, edellisiin kausiin tehdyt muutokset lisätään kuluvaan kuukauteen. Jos se on poistettu käytöstä, aiempiin kausiin tehtyjä muutoksia ei oteta huomioon.",
    "Automatically finish summary tasks": "Automatically finish summary tasks",
    "If enabled, summary tasks will be created as finished.": "If enabled, summary tasks will be created as finished.",
    "Configure data fields": "Tietokenttien määrittäminen",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Valitse vastaava Uku-kenttä jokaiselle tuodulle kentälle. Samoista kentistä tehdään yhteenveto. Jos jokin kenttä jätetään tyhjäksi, se ohitetaan.",
    "New custom field": "Uusi mukautettu kenttä",
    "Show more": "Näytä lisää",
    "Every month": "Joka kuukausi",
    "Last work day of the month": "Last work day of the month",
    "Last day of the month": "Kuun viimeinen päivä",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Ensi kuun {0}. päivä",
    "Settings saved": "Asetukset tallennettu",
    "Uku will let you know when it is ready.": "Uku ilmoittaa, kun se on valmis.",
    "Reload data": "Lataa tiedot uudelleen",
    "months": "kuukautta",
    "This will overwrite existing summary tasks new values.": "Tämä korvaa olemassa olevat yhteenvetotehtävät, uudet arvot.",
    "Overwrite": "Korvaa",
    "trigon_app_overview_text": "trigon_app_overview_text",
    "Uku will import all clients and their info from Trigon. In the final step you can select which clients you want to add or update.": "Uku will import all clients and their info from Trigon. In the final step you can select which clients you want to add or update.",
    "Connect Trigon": "Connect Trigon",
    "Before importing clients, you need to connect Uku and Trigon software. To do this, enter your credentials here.": "Before importing clients, you need to connect Uku and Trigon software. To do this, enter your credentials here.",
    "Insert email and password": "Insert email and password",
    "Automate your anti money laundering process": "Automatisoi rahanpesun vastainen prosessisi",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Olet aikeissa aktivoida rahanpesun vastaisen prosessin. Tämän aikana asiakkaidesi tietoihin lisätään uusia lisäkenttiä ja myös järjestelmä alkaa muistuttaa sinua niiden päivittämisestä.<br><br>Muita kenttiä ovat:<ul><li>Riskiprofiili<li>Profiili voimassa asti<li>AML Staus<li>Asiakirja nro<li>Asiakirja voimassa asti</li></li></li></li></li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Olet aikeissa aktivoida rahanpesun vastaisen prosessin. Tämän aikana asiakkaidesi tietoihin lisätään uusia lisäkenttiä ja myös järjestelmä alkaa muistuttaa sinua niiden päivittämisestä.<br><br>Muita kenttiä ovat:<ul><li>Riskiprofiili<li>Seuraava AML-tarkistus<li>Hyväksytty/hylätty<li>Tunnuksen tyyppi<li>Henkilötunnus<li>Viimeinen voimassaolopäivä<li>Lisätarkastukset</li></li></li></li></li></li></li></ul>",
    "Do not change client custom fields created by Uku": "Älä muuta Ukun luomia asiakkaan mukautettuja kenttiä",
    "day(s) before": "päivä(ä) ennemmin",
    "Task name": "Tehtävän nimi",
    "Assigned": "Määritetty",
    "Note": "Huomautus",
    "Manual run": "Manuaalinen ajo",
    "Create a task when the document expires": "Tehtävän luominen, kun asiakirja vanhenee",
    "Create a task when the risk profile must be updated": "Luo tehtävä, kun riskiprofiili on päivitettävä",
    "Flextime period": "Liukuva työaika",
    "Confirmation period": "Confirmation period",
    "Weekly": "Viikoittain",
    "Add agreement": "Lisää sopimus",
    "flextime_app_overview_text": "flextime_app_overview_text",
    "supplier_app_overview_text": "supplier_app_overview_text",
    "supplier_app_overview_description": "supplier_app_overview_description",
    "Supplier type": "Toimittajan tyyppi",
    "Parent type": "Ylemmän tason nimike:",
    "Edit supplier type": "Muokkaa toimittajatyyppiä",
    "New supplier type": "Uusi toimittajatyyppi",
    "Are you sure you wish to delete this supplier type?": "Haluatko varmasti poistaa tämän toimittajatyypin?",
    "Types": "Tyypit",
    "Supplier types": "Toimittajien tyypit",
    "No supplier types yet": "Ei vielä toimittajatyyppejä",
    "tripletex_app_overview_text": "tripletex_app_overview_text",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku tuo kaikki asiakkaat, asiakastiedot ja luokittelijat Tripletexistä. Viimeisessä vaiheessa voit valita, mitkä asiakkaat haluat lisätä tai päivittää.",
    "Connect Tripletex": "Yhdistä Tripletex",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Ennen asiakkaiden tuontia sinun on liitettävä Uku- ja Tripletex-ohjelmistot. Voit tehdä tämän luomalla työntekijän tunnuksen ja kirjoittamalla sen tähän.",
    "Get employee token": "Hanki työntekijätunnus",
    "Insert employee token": "Lisää työntekijätunnus",
    "Install": "Asenna",
    "Open Chrome browser to install": "Avaa Chrome-selain asentaaksesi",
    "Works with your online accounting software.": "Toimii online-kirjanpito-ohjelmistosi kanssa.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Uudet tehtävät voivat iskeä kuin salama, ja siksi Mini Uku on paras ystäväsi. Riippumatta siitä, teetkö pankkisiirtoja vai työskenteletkö kirjanpito-ohjelmistossasi; Mini Ukun avulla voit lisätä uusia tehtäviä, seurata aikaa ja pysyä ajan tasalla kaikista ilmoituksistasi miltä tahansa verkkosivustolta.<br><br>Vain yksi pöllökuvakkeen napsautus antaa yleiskuvan koko työpäivästäsi ja auttaa sinua suunnittelemaan aikataulusi tehokkaammin.",
    "merit_aktiva_app_overview_text_pl": "merit_aktiva_app_overview_text_pl",
    "merit_aktiva_app_overview_text": "merit_aktiva_app_overview_text",
    "Import clients": "Tuo asiakkaat",
    "documents_app_overview_text": "documents_app_overview_text",
    "Connect your existing document management system": "Connect your existing document management system",
    "Main folder": "Main folder",
    "Under this folder, Uku automatically creates folders for each client.": "Under this folder, Uku automatically creates folders for each client.",
    "You can customize each client folder separately under client settings.": "You can customize each client folder separately under client settings.",
    "Automatically create Public folder for client files and Private folder for member files": "Automatically create Public folder for client files and Private folder for member files",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Automatically create  Year / Month subfolder under each client for files sorting",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Automatically create  Notes and Templates subfolders under each client for files sorting",
    "Add task files added by Members": "Add task files added by Members",
    "Add task files added by Clients (from emails and client portal)": "Add task files added by Clients (from emails and client portal)",
    "Backup files to Uku file storage": "Backup files to Uku file storage",
    "Perfect example": "Perfect example",
    "Setup your SharePoint connection": "Setup your SharePoint connection",
    "Site URL": "Site URL",
    "Client ID": "Client ID",
    "Client secret": "Client secret",
    "Connection successful!": "Yhteys onnistui!",
    "When disconnecting the service Uku will no longer be able to access the documents.": "When disconnecting the service Uku will no longer be able to access the documents.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "SharePoint": "SharePoint",
    "Select folder": "Select folder",
    "Manage": "Manage",
    "Refresh": "Päivitä",
    "Be aware of the issues before they become problems": "Ole tietoinen ongelmista ennen kuin niistä tulee ongelmia",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Reaaliaikainen asiakassopimuksen ja toteutuneen työn vertailu;</li><li>Ole tietoinen ongelmista ennen kuin niistä tulee ongelmia;</li><li>Jopa kiinteillä hinnoilla sinulla on oltava sisäiset mittaukset. Seuraa asiakkaan sopimuksen pätevyyttä vertaamalla sitä todelliseen työmäärään.</li></ul>",
    "client_portal_app_overview_text": "client_portal_app_overview_text",
    "Branding": "Brändäys",
    "Subdomain": "Aliverkkotunnus",
    "Default language": "Oletuskieli",
    "Client portal URL in other languages": "Asiakasportaalin URL-osoite muilla kielillä",
    "Copy URL": "Kopioi URL-osoite",
    "Trademark": "Tavaramerkki",
    "Default signature": "Default signature",
    "Trademark text color": "Tavaramerkkitekstin väri",
    "Choose color": "Valitse väri",
    "Brand background color": "Brändin taustaväri",
    "Logo": "Logo",
    "Max. dimensions 180 x 60 px": "Mitat 180 x 60 px",
    "Favicon": "Favicon",
    "Delete icon": "Poista-kuvake",
    "Upload icon file": "Lataa kuvaketiedosto",
    "Recommended size 260 x 260 px": "Suositeltu koko 260 x 260 px",
    "Company description": "Yrityksen kuvaus",
    "Displayed on the login page.": "Näkyy kirjautumissivulla.",
    "Describe here what services you offer and how you help your clients.": "Kuvaile tässä, mitä palveluita tarjoat ja miten autat asiakkaitasi.",
    "Welcome video": "Tervetuloa video",
    "Displayed on the login page when your client contact enters for the first time": "Näkyy kirjautumissivulla, kun asiakasyhteyshenkilö saapuu ensimmäisen kerran",
    "Use Uku video": "Käytä Uku-videota",
    "View": "Näytä",
    "Use other video": "Käytä toista videota",
    "Youtube or Vimeo video URL": "Youtube- tai Vimeo-videon URL-osoite",
    "Show file upload box for client tasks": "Näytä tiedoston latausruutu asiakastehtäviä varten",
    "Invalid data": "Virheellinen tieto",
    "Client portal preview": "Asiakasportaalin esikatselu",
    "Client portal URL for {0} copied to clipboard": "Leikepöydälle kopioitujen {0} asiakasportaalin URL-osoite",
    "Personalize your client portal's menu": "Personalize your client portal's menu",
    "Menu links saved": "Menu links saved",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>",
    "Menu links": "Menu links",
    "Uku will import all clients from FreeAgent. In the final step you can select which clients you want to add or update.": "Uku will import all clients from FreeAgent. In the final step you can select which clients you want to add or update.",
    "Before importing clients, you need to connect with FreeAgent.": "Before importing clients, you need to connect with FreeAgent.",
    "Connect to FreeAgent": "Connect to FreeAgent",
    "Connected to FreeAgent": "Connected to FreeAgent",
    "freeagent_app_overview_text": "freeagent_app_overview_text",
    "Add recurring task": "Toistuvan tehtävän lisääminen",
    "Reminder tasks updated": "Muistutustehtävät päivitetty",
    "Create recurring tasks for Companies House clients.": "Luo toistuvia tehtäviä Companies House -asiakkaille.",
    "companies_house_app_overview_text": "companies_house_app_overview_text",
    "buttons": "Painikkeet",
    "Show to me": "Näytä minulle",
    "magic_button_app_overview_text": "magic_button_app_overview_text",
    "Buttons": "Painikkeet",
    "Member rights": "Jäsenen oikeudet",
    "Allow managers to view and create their client contracts and invoices": "Salli esimiesten tarkastella ja luoda asiakassopimuksia ja laskuja",
    "Allow members to view and create their client invoices": "Salli jäsenten tarkastella ja luoda asiakaslaskujaan",
    "Allow members to view their client invoices": "Salli jäsenten tarkastella asiakaslaskujaan",
    "Allow only owners to add and update products": "Salli vain omistajien lisätä ja päivittää tuotteita",
    "Allow members to send invoices to clients": "Allow members to send invoices to clients",
    "Allow members to confirm their client invoice rows": "Salli jäsenten vahvistaa asiakaslaskurivinsä",
    "Send PDF invoice": "Lähetä PDF-lasku",
    "Send invoice copy": "Send invoice copy",
    "Default rounding": "Oletuspyöristys",
    "Round all times up to x": "Pyöristää aina x:ään asti",
    "Time rounding increment": "Ajan pyöristyksen lisäys",
    "Apply time rounding to": "Käytä ajan pyöristystä",
    "Default configuration": "Oletusasetukset",
    "Invoice date": "Laskun päivämäärä",
    "Invoice entry date": "Laskun kirjauspäivä",
    "Bill tracked time by": "Lasku seurasi aikaa",
    "Bill task field by": "Laskutustehtävä-kenttä",
    "Create one invoice merging invoices from the same period": "Luo yksi lasku, joka yhdistää laskut samalta kaudelta",
    "Invoices from the same period": "Laskut samalta kaudelta",
    "Hide zero sum lines": "Nollasummarivien piilottaminen",
    "By default, time entry is billable": "Oletusarvoisesti aikamerkintä on laskutettava",
    "Invoice number": "Laskun nro",
    "Prefix": "Etuliite",
    "Suffix": "Seuraava teksti",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Laskutusasetukset tallennettu",
    "billing_app_overview_text": "billing_app_overview_text",
    "Products": "Tuotteet",
    "Contract templates": "Sopimuspohjat",
    "Invoice templates": "Laskujen mallit",
    "Tools": "Työkalut",
    "Replace tax": "Korvaa vero",
    "Old tax": "Vanha vero",
    "New tax": "Uusi vero",
    "Find tax": "Etsi vero",
    "Replace VAT in products": "Tuotteiden ALV:n korvaaminen",
    "Replace VAT in master contracts": "ALV:n korvaaminen pääsopimuksissa",
    "Replace VAT in client contracts & draft invoices": "ALV:n korvaaminen asiakassopimuksissa ja laskuluonnoksissa",
    "Replace VAT values": "ALV-arvojen korvaaminen",
    "This action cannot be undone": "Tätä toimintoa ei voida suorittaa",
    "Replace": "Korvaa",
    "Result": "Tulos",
    "PDF templates": "PDF-mallit",
    "E-mail templates": "Sähköpostimallit",
    "Edit PDF template": "Muokkaa PDF-mallia",
    "Import classificators": "Luokittelijoiden tuominen",
    "products": "tuotetta",
    "product": "tuote",
    "Product / service": "Tuote / palvelu",
    "Calculate": "Laske",
    "Article": "Artikkeli",
    "Resource": "Resurssi",
    "Cost center": "Kustannuspaikka/hankkeen numero",
    "Taxes": "Verot",
    "Code": "Tunnus",
    "Source": "Lähde",
    "Articles": "Artikkelit",
    "Resources": "Resurssit",
    "Cost centers": "Kustannuspaikat",
    "Units": "Yksiköt",
    "Unit": "Yksikkö ",
    "Bank accounts": "Tilinumerot",
    "Bank account": "Tilinumero",
    "Bank name": "Pankin nimi",
    "SWIFT code": "SWIFT-tunnus",
    "VAT number": "Y-Tunnus",
    "Do you wish to import only new data or also overwrite existing?": "Haluatko tuoda vain uusia tietoja vai korvata myös olemassa olevia?",
    "Only new": "Vain uusi",
    "New items will be added. Existing ones will remain unchanged by import.": "Uusia kohteita lisätään. Nykyiset säilyvät tuonnin myötä ennallaan.",
    "Import everything": "Tuo kaikki",
    "Connect accounting service": "Yhdistä kirjanpitopalvelu",
    "Service": "Palvelu",
    "API ID": "API-tunnus",
    "API key": "API avain",
    "Company Account Id": "Yrityksen tilin tunnus",
    "Api secret": "Api-salaisuus",
    "E-conomic": "E-conomic",
    "SmartAccounts": "Älykkäät tilit",
    "Test": "Testaa",
    "Lock time entries": "Lukitse aikamerkinnät",
    "Owner rights": "Omistajan oikeudet",
    "Disable company settings edit for all members": "Poista yritysasetusten muokkaus käytöstä kaikilta jäseniltä",
    "Disable personal clients for members": "Poista jäsenten henkilökohtaiset asiakkaat käytöstä",
    "Show member birthdays": "Näytä jäsenten syntymäpäivät",
    "Show contact birthdays": "Näytä yhteyshenkilön syntymäpäivät",
    "Weekly @ Sun {0}": "Viikoittain @ su {0}",
    "Monthly @ last day of month": "Kuukausittain @ kuukauden viimeinen päivä",
    "Company event list": "Yritystapahtumien luettelo",
    "How long?": "Kauanko?",
    "Invoice no.": "Lasku nro.",
    "Login options": "Kirjautumisvaihtoehdot",
    "Tenant ID (optional)": "Vuokraajan tunnus (valinnainen)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Lisää Active Directory -vuokraajan tunnus, jos vain tähän vuokraajaan kuuluvat käyttäjät voivat muodostaa yhteyden",
    "How to find ID’s?": "Kuinka löytää tunnukset?",
    "Microsoft connected": "Microsoft yhdistetty",
    "Google connected": "Google-yhteys",
    "Edit company": "Muokkaa yritystä",
    "Timezone": "Aikavyöhyke",
    "Invoice email": "Laskun sähköposti",
    "Subscription plan": "Tilaus",
    "Payment failed": "Maksu epäonnistui",
    "Retry payment": "Yritä maksua uudelleen",
    "Next payment": "Seuraava maksu",
    "Update payment method": "Päivitä maksutapa",
    "Plan": "Suunnitelma",
    "Choose a plan": "Valitse suunnitelma",
    "Change plan": "Muuta suunnitelmaa",
    "{0}-day free trial until {1}": "{0} päivän ilmainen kokeilujakso vuoteen {1} asti",
    "monthly": "kuukausittain",
    "yearly": "vuosittain",
    "{0} member": "{0} jäsen",
    "{0} members": "{0} jäsentä",
    "{0} plan": "{0} suunnitelma",
    "Cancelled (valid until {0})": "Peruttu (voimassa vuoteen {0})",
    "Your trial expired on {0}": "Kokeilujaksosi päättyi {0}",
    "Your subscription expired on {0}": "Tilauksesi päättyi {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Kiva nähdä! Jos haluat aloittaa Uku-tilauksen, klikkaa Valitse tilaus",
    "Save {0} by paying for a year!": "Säästä {0} maksamalla vuosi!",
    "Choose plan": "Valitse tilauspaketti",
    "Pay annually": "Maksa vuosittain",
    "Instructions sent!": "Ohjeet lähetetty!",
    "Instructions for resetting your password have been sent to": "Ohjeet salasanan vaihtamiseen on lähetetty osoitteeseen",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Saat tämän sähköpostin 5 minuutin kuluessa. Muista tarkistaa myös roskapostikansiosi.",
    "Back to login page": "Takaisin kirjautumissivulle",
    "Get new password": "Salasanan uusiminen",
    "Pick a password": "Valitse salasana",
    "Use minimum 8 characters with letters & numbers": "Käytä vähintään 8 merkkiä kirjainten ja numeroiden kanssa",
    "Create your Uku Account": "Luo Uku-tili",
    "Connect your Xero Account": "Yhdistä Xero-tilisi",
    "Phone": "Puhelinnumero",
    "I agree to the": "Hyväksyn ",
    "Terms of Service": "käyttöehdot",
    "Next": "Seuraava",
    "Having trouble?": "Ongelmia?",
    "We can help": "Me voimme auttaa",
    "Log in instead": "Kirjaudu sen sijaan sisään",
    "You are invited to join": "Olet tervetullut liittymään",
    "Accept invitation": "Hyväksy kutsu",
    "Check your email": "Tarkista sähköpostisi",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Lähetin sinulle sähköpostin, jossa oli linkki tilisi aktivoimiseksi. Tämä on tärkeää tilisi turvallisuuden varmistamiseksi.",
    "Go to": "Mene",
    "Need a new password?": "Tarvitsetko uuden salasanan?",
    "Enter your e-mail address and we will send you directions for changing your password": "Syötä sähköpostiosoitteesi ja lähetämme sinulle ohjeet salasanan vaihtamiseksi",
    "Send me instructions": "Lähetä minulle ohjeet",
    "Never mind, go back": "Älä välitä, palaa takaisin",
    "No login options enabled. Please contact the company owner": "Kirjautumisvaihtoehtoja ei ole käytössä. Ota yhteyttä yrityksen omistajaan",
    "Log in to Uku": "Kirjaudu Ukuun",
    "Forgot password?": "Unohtuiko salasana?",
    "Don't have account?": "Eikö sinulla ole tiliä?",
    "Create account": "Luo tili",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Nro 1 työkalu kirjanpitokäytäntöihin. Automatisoidut työnkulut, työajanseuranta, raportit, seuranta, CRM. Tee työt ajallaan & kannattavasti. Kokeile ilmaiseksi!",
    "Total items:": "Kohteita yhteensä:",
    "Add new": "Lisää uusi",
    "Amount": "Summa",
    "Account created range": "Tilin luoma alue",
    "Usage limit": "Käyttöraja",
    "Valid until": "Voimassa",
    "Edit help link": "Muokkaa ohjelinkkiä",
    "New help link": "Uusi ohjelinkki",
    "Name key": "Nimiavain",
    "Country code": "Maatunnus",
    "Period (months)": "Ajanjakso (kuukautta)",
    "Account created from": "Tili, joka on luotu",
    "Account created until": "Tili luotu, kunnes",
    "Used count": "Käytetty määrä",
    "Free days": "Free days",
    "Sum": "Summa",
    "Create voucher": "Luo kuponki",
    "Edit voucher": "Muokka lahjakortti",
    "Are you sure to delete this voucher?": "Oletko varma, että poistat tämän kupongin?",
    "row | rows": "rivi | Rivit",
    "Add event": "Lisää tapahtuma",
    "Are you sure you wish to delete this event?": "Haluatko varmasti poistaa tämän tapahtuman?",
    "event | events": "Tapahtuma | Tapahtumia",
    "Security object id": "Suojausobjektin tunnus",
    "Direct rights": "Suorat oikeudet",
    "Computed rights": "Laskennalliset oikeudet",
    "Add link": "Lisää linkki",
    "Are you sure you wish to delete this entry?": "Haluatko varmasti poistaa tämän merkinnän?",
    "link | links": "linkki | Linkkejä",
    "Event type": "Tapahtumatyyppi",
    "Date from": "Päivästä alkaen",
    "Date until": "Päivämäärä asti",
    "Shortened by h": "Lyhennetty h",
    "Category": "Kategoria",
    "demo | demos": "esittely | Demoja",
    "Created at": "Created at",
    "Invited by": "Invited by",
    "referral | referrals": "referral | referrals",
    "Companies": "Yritykset",
    "Leads": "Liidit",
    "Demos": "Demot",
    "Vouchers": "Lahjakortit",
    "KPI": "KPI",
    "Referrals": "Referrals",
    "Activity log": "Toimintaloki",
    "Notifications": "Ilmoitukset",
    "Me": "Minä",
    "Important notifications will appear here.": "Tähän ilmestyvät tärkeät ilmoitukset. ",
    "Back": "Takaisin",
    "Return to UKU": "Palaa UKU:hun",
    "Choose plan for {0}": "Valitse tilaus {0}",
    "First payment will be made after the end of the trial period.": "Ensimmäinen maksu suoritetaan koeajan päätyttyä.",
    "Members and subscription can always be changed.": "Jäseniä ja tilausta voi aina muuttaa.",
    "Your subscription is externally managed by Xero": "Your subscription is externally managed by Xero",
    "Select plan": "Select plan",
    "Billing period": "Laskutuskausi",
    "Compare features": "Vertaile ominaisuuksia",
    "Cancel uku subscription": "Peruuta uku-tilaus",
    "{0} discount": "{0} alennus",
    "You have currently<br />{0} active member": "Sinulla on tällä hetkellä<br />{0} aktiivinen jäsen",
    "You have currently<br />{0} active members": "Sinulla on tällä hetkellä<br />{0} Aktiiviset jäsenet",
    "Select yearly plan": "Valitse vuosisopimus",
    "Select monthly plan": "Valitse kuukausitilaus",
    "Attention!": "Huomio!",
    "Plan change request": "Plan change request",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Jos haluat käyttää Ukua ilmaiseksi, poista tilisi käytöstä ja jatka {0} suunnitelmaa",
    "per member/month (billed yearly)": "per jäsen/kuukausi (laskutetaan vuosittain)",
    "or {0} per member/month (monthly)": "tai {0} jäsentä/kuukautta kohti (kuukausittain)",
    "Everything in {0}, plus:": "Kaikki {0}, sekä:",
    "Compare plans, feature-by-feature": "Vertaile palvelupaketteja ominaisuuskohtaisesti",
    "Deactivate account": "Poista tili käytöstä",
    "Are you sure to deactivate {0} account?": "Oletko varma, että poistat {0} tilin käytöstä?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Jos päätät jatkaa freelancer-suunnitelmaa, yritystilisi poistetaan käytöstä. Tähän yritykseen liittyvät tiedot poistetaan.",
    "Deactivate": "Deaktivoi",
    "Teamwork": "Tiimityö",
    "Unlimited clients + import": "Rajoittamaton määrä asiakkaita + tuonti",
    "Access management": "Käyttöoikeuksienhallinta",
    "Custom fields": "Mukautetut kentät",
    "Live chat support": "Live-chat-tuki",
    "AML": "AML",
    "API": "API",
    "Client Portal": "Asiakasportaali",
    "New!": "Uusi!",
    "Custom integrations": "Mukautetut integraatiot",
    "Assisted clients import": "Avustettujen asiakkaiden tuonti",
    "Tailor-made team workshop": "Räätälöity tiimityöpaja",
    "Early access to features": "Ominaisuuksien ennakkokäyttö",
    "Pay by invoice": "Maksa laskulla",
    "Dedicated account manager": "Omistautunut tilinhoitaja",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Moikka! Kokeilujaksosi on ohi. Valitse {0} tilaussuunnitelma jatkaaksesi työtä",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Moikka! Sinun on päivitettävä {0} tilaussuunnitelma, jotta voit käyttää tätä ominaisuutta",
    "Waiting for the subscription to complete": "Waiting for the subscription to complete",
    "VAT": "ALV",
    "This is subscription period amount.": "Tämä on merkintäajan summa.",
    "You save yearly {0}": "Säästät vuosittain {0}",
    "Add voucher": "Lisää lahjakortti",
    "Existing credit": "Olemassa oleva luotto",
    "Current payment": "Juokseva maksu",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Tämä on nykyinen maksusumma. Pankkisi vaatii myös vahvistuksen merkintäajan summalle.",
    "Confirm subscription {0}": "Vahvista tilauksen {0}",
    "Your subscription will renew on": "Tilauksesi uusitaan",
    "Thank you for believing in us!": "Kiitos, että uskot meihin!",
    "Uku team": "Uku-tiimi",
    "Voucher {1} (-{0}%)": "Setelin {1} (-{0}%)",
    "Voucher {0}": "Kuponki {0}",
    "New plan": "Uusi suunnitelma",
    "Changed plan": "Muutettu suunnitelma",
    "Add {0} member": "Lisää {0} jäsen",
    "Add {0} members": "Lisää {0} jäsentä",
    "Remove {0} member": "Poista {0} jäsen",
    "Remove {0} members": "Poista {0} jäsentä",
    "No changes to plan": "Ei muutoksia suunnitelmaan",
    "Discount -{0}% with Yearly subscription": "Alennus -{0}% vuositilauksella",
    "Yearly discounted price (-{0}%)": "Vuosittainen alennettu hinta (-{0}%)",
    "Subscription updated": "Tilaus päivitetty",
    "Please wait": "Odota hetki",
    "Your payment failed": "Maksusi epäonnistui",
    "Please check that you entered the data correctly or use another card": "Tarkista, että syötit tiedot oikein tai käytä toista korttia",
    "Try again": "Yritä uudelleen",
    "Pay": "Maksa",
    "Payment": "Maksu",
    "Payment method updated": "Maksutapa päivitetty",
    "Edit member": "Muokkaa jäsentä",
    "First name": "Etunimi",
    "Last name": "Sukunimi",
    "External ID": "Tunniste",
    "Select groups": "Valitse ryhmät",
    "Administrator": "Ylläpitäjä",
    "Activate member": "Aktivoi jäsen",
    "Deactivate member": "Poista jäsen käytöstä",
    "Paid member": "Maksettu jäsen",
    "Send an invitation": "Lähetä kutsu",
    "Limited": "Rajoitettu",
    "No invite, no access": "Ei kutsua, ei pääsyä",
    "Free until activated": "Ilmainen, kunnes se aktivoidaan",
    "No access, no charge": "Ei pääsyä, ei maksua",
    "Hidden member": "Piilotettu jäsen",
    "Edit members": "Muokkaa jäseniä",
    "Select user": "Valitse käyttäjä",
    "Member will be assigned to every selected client": "Jäsen osoitetaan jokaiselle valitulle asiakkaalle",
    "Member will be removed from all selected clients": "Jäsen poistetaan kaikista valituista asiakkaista",
    "Assign user": "Liitä käyttäjä",
    "Set as primary user": "Aseta ensisijaiseksi käyttäjäksi",
    "Added as a default user when adding a task plan": "Lisätty oletuskäyttäjäksi tehtäväsuunnitelmaa lisättäessä",
    "Remove from new tasks": "Poista uusista tehtävistä",
    "Remove from plan tasks": "Poista suunnitelluista tehtävistä ",
    "Remove": "Poista",
    "Admin": "Pääkäyttäjä",
    "Remove user": "Poista käyttäjä",
    "Assign to incomplete tasks": "Määritä keskeneräiset tehtävät ",
    "Reassign incomplete tasks": "Määritä keskeneräiset tehtävät uudelleen",
    "Assign to plan tasks": "Määritä suunnittelutehtäviin",
    "Reassign plan tasks": "Määritä suunnittelutehtävät uudelleen ",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Jos poistettava käyttäjä on tehtävän ainoa käyttäjä, tehtävä suunnataan omistajalle. ",
    "Run integration": "Suorita integrointi",
    "Run": "Suorita",
    "Integration configuration": "Integroinnin määritys",
    "Read the manual": "Lue käyttöohje",
    "Api key": "Api avain",
    "Are you sure to delete this integration info?": "Poistatko varmasti nämä integrointitiedot?",
    "Edit Contracts": "Muokkaa sopimuksia",
    "Replace following contracts": "Korvaa seuraavat sopimukset",
    "Append services to following contracts": "Liitä palvelut seuraaviin sopimuksiin",
    "Choose template": "Valitse malline",
    "Append only": "Vain liittäminen",
    "with template": "mallin kanssa",
    "All existing contracts": "Kaikki voimassa olevat sopimukset",
    "All quarterly contracts": "Kaikki neljännesvuosittaiset sopimukset",
    "All monthly contracts": "Kaikki kuukausisopimukset",
    "All yearly contracts": "Kaikki vuosisopimukset",
    "Next invoice number": "Seuraavan laskun numero",
    "Number is too big, it cannot exceed 15 digits": "Numero on liian suuri, se ei voi ylittää 15 numeroa",
    "Replace topic": "Korvaa aihe",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "Kaikki nykyisen aiheen tehtävät ja suunnitelmat korvataan uudella valitulla aiheella.",
    "Topics replaced": "Aiheet korvattu",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Kaikki tehtävät, joiden aihe on \"{0}\", korvataan tehtävällä \"{1}\". Tätä ei voi peruuttaa. Oletko varma?",
    "Name of topic": "Aiheen nimi",
    "New time entries will be marked as non-billable": "New time entries will be marked as non-billable",
    "Change topic": "Vaihda aihetta",
    "Add new topic": "Lisää uusi aihe",
    "This topic is in use. Do you wish to archive it?": "Tämä ohjeaihe on käytössä. Haluatko arkistoida sen?",
    "Are you sure that you want to delete this topic?": "Oletko varma, että haluat poistaa tämän aiheen?",
    "These items will be deleted permanently": "Nämä kohteet poistetaan pysyvästi",
    "Are you sure that you want to delete this client group?": "Haluatko varmasti poistaa tämän asiakasryhmän?",
    "This client group is in use. Do you wish to archive it?": "Tämä asiakasryhmä on käytössä. Haluatko arkistoida sen?",
    "Edit client group": "Muokkaa asiakasryhmää",
    "New client group": "Uusi asiakasryhmä",
    "Price": "Hinta",
    "Quantity": "Määrä",
    "Unit will be translated to client language": "Yksikkö käännetään asiakkaan kielelle",
    "Pick date & time": "Valitse päivämäärä ja aika",
    "Share equally": "Jaa tasan",
    "Change existing": "Muuta olemassa olevaa",
    "Choose bookmark": "Valitse kirjanmerkki",
    "New title": "Uusi otsikko",
    "Set as my default view": "Aseta oletusnäkymäksi",
    "Signature name": "Signature name",
    "Layout": "Layout",
    "Top": "Top",
    "Middle": "Middle",
    "Bottom": "Bottom",
    "Logo left": "Logo left",
    "Logo top": "Logo top",
    "No logo": "No logo",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "Email signature",
    "Edit email signature": "Edit email signature",
    "Add email signature": "Add email signature",
    "Font color": "Font color",
    "Actions": "Toiminnot",
    "Delete signature": "Delete signature",
    "Do you wish to update related contracts and invoices?": "Haluatko päivittää niihin liittyviä sopimuksia ja laskuja?",
    "Update contract templates, active contracts and open invoices.": "Päivitä sopimuspohjat, aktiiviset sopimukset ja avoimet laskut.",
    "The following fields will be updated": "Seuraavat kentät päivitetään:",
    "Custom Value": "Muokattu arvo",
    "This product is in use. Do you wish to archive it?": "Tämä tuote on käytössä. Haluatko arkistoida sen?",
    "Are you sure that you want to delete this product?": "Oletko varma, että haluat poistaa tämän tuotteen?",
    "Customize for client": "Mukauta asiakkaalle",
    "Customize for template": "Mallin mukauttaminen",
    "Open product template": "Avaa tuotemalli",
    "Create product template": "Luo tuotemalli",
    "Master template": "Päämalli",
    "Client product": "Asiakkaan tuote",
    "Client product / service": "Asiakkaan tuote / palvelu",
    "New client product": "Uusi asiakastuote",
    "Template product": "Mallin tuote",
    "Template product / service": "Malli tuote / palvelu",
    "New template product": "Uusi mallituote",
    "Edit translations": "Muokkaa käännöksiä",
    "Billable topics": "Laskutettavat aiheet",
    "Billable time": "Laskutettava aika",
    "Minimum quantity": "Vähimmäismäärä",
    "Minimum time": "Vähimmäisaika",
    "Integration parameters": "Integroinnin parametrit",
    "Empty values will use product default": "Tyhjät arvot käyttävät tuotteen oletusarvoa",
    "Pricing": "Hinnoittelu",
    "DC %": "Ale %",
    "Sum all matching rows": "Kaikkien vastaavien rivien yhteenlaskeminen",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "Kun tämä asetus on käytössä, kokonaishinta on kaikkien vastaavien rivien kumulatiivinen summa. Kokonaishinta käyttää oletusarvoisesti vain korkeinta vastaavaa riviä.",
    "Prices since": "Hinnat vuodesta",
    "Add price": "Lisää hinta",
    "Add pricing period": "Lisää hinnoittelujakso",
    "Update contracts": "Päivitä sopimukset",
    "(Without topic)": "(ei aihetta)",
    "Fixed price": "Perushinta",
    "Product": "Tuote",
    "Event created": "Tapahtuma luotiin",
    "Project created": "Luotu projekti",
    "Event deleted": "Tapahtuma poistettu",
    "Project deleted": "Hanke poistettu",
    "Workflow added": "Työnkulku lisätty",
    "Workflow removed": "Työnkulku poistettu",
    "Workflow updated": "Työnkulku päivitetty",
    "Event cancelled": "Tapahtuma peruttu",
    "Project cancelled": "Hanke peruttu",
    "Event reactivated": "Tapahtuma aktivoitu uudelleen",
    "Project reactivated": "Projekti aktivoitu uudelleen",
    "Event archived": "Tapahtuma arkistoitu",
    "Project archived": "Projekti arkistoitu",
    "Event unarchived": "Tapahtuma arkistoimaton",
    "Project unarchived": "Projekti arkistoimaton",
    "Event changed": "Tapahtuma muuttunut",
    "Project changed": "Projekti muuttui",
    "Event status changed: {0}": "Tapahtuman tila muuttunut: {0}",
    "Project status changed: {0}": "Projektin tila muuttunut: {0}",
    "Event status changed": "Tapahtuman tila muuttunut",
    "Project status changed": "Projektin tila muuttunut",
    "Task created": "Luotu tehtävä",
    "Task changed": "Tehtävä muuttunut",
    "Task finished": "Tehtävä suoritettu",
    "Task not finished": "Tehtävä ei päättynyt",
    "Task deleted": "Tehtävä poistettu",
    "Add project": "Lisää projekti",
    "Hide filters": "Piilota rajaus",
    "Show filters": "Näytä suodattimet",
    "Cancel event": "Peruuta tapahtuma",
    "Cancel project": "Peruuta projekti",
    "Manage event fields": "Tapahtumakenttien hallinta",
    "Manage project fields": "Projektikenttien hallinta",
    "New event": "Uusi tapahtuma",
    "New project": "Uusi projekti",
    "{0} (Copy)": "{0} (Kopioi)",
    "Are you sure you wish to delete this project?": "Haluatko varmasti poistaa tämän projektin?",
    "Are you sure to archive this event?": "Oletko varma, että arkistoit tämän tapahtuman?",
    "Are you sure to archive this project?": "Oletko varma, että arkistoit tämän projektin?",
    "Are you sure to cancel this event?": "Oletko varma, että peruutat tämän tapahtuman?",
    "Are you sure to cancel this project?": "Oletko varma, että peruutat tämän projektin?",
    "Communication": "Viestintä",
    "Log": "Loki",
    "Create event workflow": "Tapahtuman työnkulun luominen",
    "Create project workflow": "Luo projektin työnkulku",
    "Use workflow templates to set up tasks effectively or": "Määritä tehtävät tehokkaasti työnkulkumallien avulla tai",
    "Add tasks manually": "Tehtävien lisääminen manuaalisesti",
    "Save bookmark": "Tallenna kirjanmerkki",
    "Remove filters": "Poista rajaukset",
    "Filter": "Suodatin",
    "Show multiselect": "Näytä monivalinta",
    "To do today": "Tehdä tänään",
    "This and next month": "Tässä ja ensi kuussa",
    "Last 3 months": "Viimeiset 3 kuukautta",
    "Next 3 months": "Seuraavat 3 kuukautta",
    "Starts": "Alkaa",
    "To do": "Tehdä",
    "today": "tänään",
    "tomorrow": "huomenna",
    "yesterday": "eilen",
    "Previous week": "Edellinen viikko",
    "Group similar tasks": "Samankaltaisten tehtävien ryhmittely",
    "Group by client": "Ryhmittely asiakkaan mukaan",
    "Group by date": "Ryhmittele päivämäärän mukaan",
    "Group by topic": "Ryhmittely aiheen mukaan",
    "Are you sure to remove google?": "Oletko varma, että poistat googlen?",
    "Google log in": "Google-sisäänkirjautuminen",
    "Microsoft log in": "Microsoftin kirjautuminen sisään",
    "Are you sure to remove microsoft?": "Oletko varma, että poistat Microsoftin?",
    "Are you want to disconnect Xero?": "Are you want to disconnect Xero?",
    "Reset password": "Reset password",
    "Your details": "Tietosi",
    "City": "Kaupunki",
    "Regional format": "Alueellinen muoto",
    "Default company": "Oletusyritys",
    "Lock time entries notification": "Lukitusaikamerkintöjen ilmoitus",
    "Notify by": "Ilmoita",
    "Delete my account": "Poista tilini",
    "Attention": "Huomio",
    "Are you sure that you want to delete your account?": "Oletko varma, että haluat poistaa tilisi?  ",
    "Notification": "Ilmoitus",
    "Notification & email": "Ilmoitukset & sähköposti",
    "Vacations / absence": "Lomat / poissaolot",
    "Edit balance": "Muokkaa saldoa",
    "View history": "Näytä historia",
    "Request": "Pyyntö",
    "How long": "Kauanko",
    "Requested": "Tulostettu",
    "Approved": "Hyväksytty",
    "Rejected": "Hylätty",
    "In review": "Tarkastelussa",
    "Change": "Muuta",
    "Agreements": "Sopimukset",
    "New agreement": "Uusi sopimus",
    "Change agreement": "Vaihda sopimus",
    "Stop demo": "Lopeta demo",
    "Show": "Näytä",
    "Don't show": "Älä näytä",
    "Don't send": "Älä lähetä",
    "Email workdays at 7 AM": "Sähköposti arkisin klo 7:00",
    "Email at 3 PM": "Sähköposti klo 15:00",
    "Email at once": "Sähköposti heti",
    "Email Sundays at 11 PM": "Sähköposti sunnuntaisin klo 23:00",
    "First day of the month": "Joka kuukauden 1. pvä",
    "to email": "sähköpostiin",
    "E-mail at once": "Sähköpostiin heti",
    "System": "Järjestelmä",
    "Person": "Henkilö",
    "Picture": "Kuva",
    "Time zone": "Aikavyöhyke",
    "Calendar settings": "Kalenterin asetukset",
    "Public holidays": "Yleiset vapaapäivät",
    "Tax deadlines": "Verojen määräajat",
    "News": "Ajankohtaista",
    "External services": "Ulkoiset palvelut",
    "Agreement": "Sopimus",
    "Active agreement": "Aktiivinen sopimus",
    "Weekly hours": "Viikoittaiset tunnit",
    "Edit supplier": "Muokkaa toimittajaa",
    "New supplier": "Uusi toimittaja",
    "Are you sure you wish to delete this supplier?": "Haluatko varmasti poistaa tämän toimittajan?",
    "Add supplier": "Lisää Toimittaja",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Toimittajatyyppejä ei ole määritelty. Siirry toimittajien sovellusasetuksiin lisätäksesi.",
    "No members yet": "Ei vielä jäseniä",
    "Edit group": "Muokkaa ryhmää",
    "Add group": "Lisää ryhmä",
    "Are you sure to delete this user group?": "Oletko varma, että poistat tämän käyttäjäryhmän?",
    "Get set up to work with team": "Työryhmän kanssa työskentelyn valmistelu",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Yritystilin avulla voit käyttää työkaluja tiimeille, saada syvempiä oivalluksia jne. Nosta tiimisi työnkulun laatua ja johda kannattavampaa liiketoimintaa.",
    "Create company account": "Luo yritystili",
    "By creating a company account you activate Uku free subscription for {0} days.": "Luomalla yritystilin aktivoit Uku-ilmaisen tilauksen {0} päivän ajan.",
    "You have invited {0}/{1} members": "Olet kutsunut {0}/{1} jäsentä",
    "Upgrade": "Päivitä",
    "View profile": "Näytä profiili",
    "To add members to your team, you'll need to create a company account": "Jos haluat lisätä jäseniä tiimiisi, sinun on luotava yritystili",
    "Export": "Vie",
    "Re-invite sent": "Kutsu lähetetty uudelleen",
    "View report": "Tarkastele raporttia",
    "Member {0} will be deactivated.": "Jäsenten {0} poistetaan käytöstä.",
    "Please select new member who will replace {0}.": "Valitse uusi jäsen, joka korvaa {0}.",
    "Select new member": "Valitse uusi jäsen",
    "NB! Deactivation process cannot be reversed": "HUOM! Deaktivointiprosessia ei voi peruuttaa",
    "Magic button settings": "Taikapainikkeen asetukset",
    "Create only one task per month": "Luo vain yksi tehtävä kuukaudessa",
    "Current month's tasks": "Kuluvan kuukauden tehtävät",
    "extra work": "lisätyö",
    "Without topic": "Ilman aihetta",
    "Week": "Viikko",
    "Previous month": "Edellinen kuukausi",
    "task | tasks": "Tehtävä | Tehtävät",
    "Assign to": "Vastuuta",
    "Mark as done": "Merkitse tehdyksi",
    "Last": "Viimeinen",
    "Snooze": "Torkut",
    "1 dependency": "1 riippuvuus",
    "{0} dependencies": "{0} riippuvuudet",
    "Client request": "Asiakkaan pyyntö",
    "Unread notification emails": "Unread notification emails",
    "Unread internal comments": "Unread internal comments",
    "Add comment": "Lisää kommentti",
    "Internal comment": "Sisäinen kommentti",
    "Portal message": "Portaalin viesti",
    "Public message means that clients can read it and the client portal will notify them by email": "Julkinen viesti tarkoittaa, että asiakkaat voivat lukea sen ja asiakasportaali ilmoittaa heille sähköpostitse",
    "Type a comment": "Kirjoita kommentti",
    "Send portal message": "Lähetä portaaliviesti",
    "Open timesheet": "Avaa työaikaraportti",
    "Pause timer": "Pysäytä ajastin väliaikaisesti",
    "Mark undone": "Merkitse kumotuksi",
    "Digitise": "Digitalisoi",
    "Documents sent to digitisation": "Digitointiin lähetetyt asiakirjat",
    "Followers": "Seuraajat",
    "Start / Due date": "Aloitus- / eräpäivä",
    "Select topic": "Valitse aihe",
    "1 document": "1 asiakirja",
    "{0} documents": "{0} asiakirjat",
    "Download": "Lataa verkosta",
    "Download all": "Lataa kaikki",
    "Primary contact": "Primary contact",
    "Assign as task": "Määritä tehtäväksi",
    "When selected, the task is sent as a task to the client": "Kun tämä on valittuna, tehtävä lähetetään tehtävänä asiakkaalle",
    "Auto finish": "Automaattinen viimeistely",
    "When selected, the task is marked done after client finishes it": "Kun tämä on valittuna, tehtävä merkitään suoritetuksi, kun asiakas on suorittanut sen",
    "Add comment / message": "Lisää kommentti / viesti",
    "Add email": "Lisää sähköposti",
    "Add estimation": "Lisää arvio",
    "Add task field": "Lisää tehtäväkenttä",
    "Add dependency": "Lisää riippuvuus",
    "Drop files to upload": "Pudota kuvat tänne ladataksesi ne",
    "Task sent to client portal": "Asiakasportaaliin lähetetty tehtävä",
    "Task no longer assigned to client portal": "Tehtävää ei ole enää määritetty asiakasportaaliin",
    "Save recurring task": "Toistuvan tehtävän tallentaminen",
    "Add to-do list": "Lisää tehtäväluettelo",
    "Waiting for event status: {0}": "Odotetaan tapahtuman tilaa: {0}",
    "Waiting for project status: {0}": "Odotetaan projektin tilaa: {0}",
    "Edit template task": "Muokkaa mallitehtävää",
    "Create recurring task": "Toistuvan tehtävän luominen",
    "Make a copy": "Kopioi",
    "Add topic": "Lisää aihe",
    "Delete task": "Poista tehtävä",
    "Delete task template": "Poista tehtävämalli",
    "Select task field": "Valitse tehtäväkenttä",
    "No custom fields available for this client": "Tälle asiakkaalle ei ole käytettävissä mukautettuja kenttiä",
    "task": "tehtävä",
    "recurring task": "Toistuva tehtävä",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Aiotko poistaa itsesi {0} vai haluatko poistaa sen kokonaan?",
    "This {1} is shared with {0}": "Tämä {1} jaetaan {0} kanssa",
    "Remove only me": "Poista vain minut",
    "Time has been tracked to this task.": "Tähän tehtävään on seurattu aikaa.",
    "Are you sure to delete this task?": "Oletko varma, että poistat tämän tehtävän?",
    "Undefined": "Määrittämätön",
    "COPY": "KOPIOI",
    "On task due date": "Tehtävän määräpäivänä",
    "{0} day before": "{0} päivää ennen",
    "{0} days before": "{0} päivää ennen",
    "Edit workflow": "Muokkaa työnkulkua",
    "Duplicate project": "Projektin monistaminen",
    "Reset layout": "Palauta asettelu",
    "Any time": "Mikä tahansa aika",
    "1 min": "1 min",
    "5 min": "5 min",
    "10 min": "10 min",
    "30 min": "30 minuuttia",
    "1 h": "1 h",
    "Add notes": "Lisää huomautuksia",
    "Task start date": "Tehtävän alkamispäivä",
    "Task due date": "Tehtävän määräpäivä",
    "Recurrence task": "Toistuminen-tehtävä",
    "Search from one time templates": "Haku kertaluonteisista malleista",
    "Placeholders": "Paikanpitäjät",
    "New task": "Uusi tehtävä",
    "New recurring task": "Uusi toistuva tehtävä",
    "+1 day": "+1 päivä",
    "Edit comment": "Muokkaa kommenttia",
    "Timer is running!": "Ajastin on käynnissä!",
    "Continue time from {0}": "Jatka aikaa vuodesta {0}",
    "New time entry": "Uusi aikamerkintä",
    "Load more": "Lataa lisää",
    "Are you sure to delete this time entry?": "Oletko varma, että poistat tämän aikamerkinnän?",
    "Save automated email": "Tallenna automaattinen sähköposti",
    "Automation": "Automatisointi",
    "Are you sure to delete this email?": "Oletko varma, että poistat tämän sähköpostin?",
    "Are you sure you wish to send this email immediately?": "Haluatko varmasti lähettää tämän sähköpostin heti?",
    "replied to project email": "replied to project email",
    "replied to client email": "replied to client email",
    "commented": "kommentoitu",
    "Reply": "Vastaa",
    "Are you sure to delete this comment?": "Oletko varma, että poistat tämän kommentin?",
    "replied to client portal email": "replied to client portal email",
    "sent a message": "lähetti viestin",
    "replied to task email": "replied to task email",
    "failed to send": "Lähetys epäonnistui",
    "sent email": "lähetetty sähköposti",
    "no one": "ei kukaan",
    "created this task.": "loi tämän tehtävän.",
    "Task was automatically created from forwarded e-mail": "Task was automatically created from forwarded e-mail",
    "Task was automatically created from client portal e-mail": "Task was automatically created from client portal e-mail",
    "Task was automatically created from client e-mail": "Task was automatically created from client e-mail",
    "Task was automatically created from project e-mail": "Task was automatically created from project e-mail",
    "requested assistance.": "pyydetty apu.",
    "updated this task.": "Päivitetty tämä tehtävä.",
    "tracked time to this task.": "seurasi tähän tehtävään kuluvaa aikaa.",
    "finished this task.": "suoritti tämän tehtävän.",
    "new comment.": "Uusi kommentti.",
    "reassigned this task.": "Määritä tämä tehtävä uudelleen.",
    "assigned the task to {0}.": "Määritä tehtävä {0}.",
    "reminder.": "muistutus.",
    "deleted.": "Poistaa.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "suoritti tehtävän, mutta Uku ei suorittanut tehtävää automaattisesti, koska kaikki tehtävän vaatimukset eivät täyttyneet.",
    "sent task to client portal": "Lähetetty tehtävä asiakasportaaliin",
    "assigned the task to client.": "Määritä tehtävä asiakkaalle.",
    "assigned the task to company.": "Määritä tehtävä yritykselle.",
    "added attachment(s).": "Lisätty liitteet.",
    "added a comment.": "lisätty kommentti.",
    "added a message to {0}.": "Lisätty viesti {0}.",
    "received a e-mail from {0}.": "received a e-mail from {0}.",
    "updated notes.": "Päivitetyt muistiinpanot.",
    "made changes to checklist.": "Tehty muutoksia tarkistuslistaan.",
    "created this task template.": "loi tämän tehtävämallin.",
    "updated this task template.": "Päivitetty tämä tehtävämalli.",
    "recurring task assigned.": "Toistuva tehtävä määritetty.",
    "recurring task deleted.": "Toistuva tehtävä poistettu.",
    "added email.": "Lisätty sähköposti.",
    "changed email.": "Muutettu sähköpostiosoite.",
    "deleted email.": "poistettu sähköposti.",
    "sent email.": "lähetetty sähköposti.",
    "failed to send.": "Lähetys epäonnistui.",
    "added email": "Lisätty sähköpostiosoite",
    "changed email": "Muutettu sähköpostiosoite",
    "deleted email": "Poistettu sähköposti",
    "Member / Time": "Jäsen / Aika",
    "Client/topic": "Asiakas/aihe",
    "Client/task": "Asiakas/tehtävä",
    "Client/member": "Asiakas/jäsen",
    "Member/topic": "Jäsen/aihe",
    "Member/task": "Jäsen/tehtävä",
    "Member/client": "Jäsen/asiakas",
    "Member/date": "Jäsen/päivämäärä",
    "Date/member": "Päivämäärä/jäsen",
    "Grouped": "Ryhmitetty",
    "Client/project": "Asiakas/projekti",
    "Project/member": "Projekti/jäsen",
    "Period balance": "Kauden saldo",
    "Reset balance": "Palauta saldo",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Aikasyöttö on vahvistettu tai kestoa on muutettu, eikä kesto päivity dynaamisesti",
    "(Without project)": "(Ilman projektia)",
    "Decline": "Hylkää",
    "Accept": "Hyväksy",
    "Cancel decision": "Päätöksen peruuttaminen",
    "Accepted": "Hyväksytty",
    "Declined": "Hylätty",
    "Report data has changed. Please update report.": "Raportin tiedot ovat muuttuneet. Päivitä raportti.",
    "Agreed": "Sovittu",
    "Non billable": "Ei laskutettava",
    "Estimation report shows based on task start date": "Estimation report shows based on task start date",
    "Export report to Excel": "Vie raportti Exceliin",
    "By default, we export the result of the selected filters with the columns of the configured table": "Oletusarvoisesti viemme valittujen suodattimien tulokset määritetyn taulukon sarakkeisiin",
    "Add to export client custom fields": "Lisää vientiasiakkaan mukautettuihin kenttiin",
    "Save report": "Tallenna raportti",
    "Export PDF": "Vie PDF",
    "Export Excel": "Vie Excel",
    "Extra": "Lisää",
    "done": "tehty",
    "h": "h",
    "We have new version of": "Meillä on uusi versio",
    "Log out": "Kirjaudu ulos",
    "Previous day": "Edellinen päivä",
    "Next day": "Seuraava päivä",
    "Mark all as read": "Merkitse kaikki luetuksi",
    "Search task/client": "Hae tehtävästä/asiakkaasta",
    "from client portal": "asiakasportaalista",
    "Hide all": "Piilota kaikki",
    "Hide for 1 hour": "Piilota 1 tunti",
    "Something went wrong": "Jokin meni vikaan",
    "User authentication needed": "Käyttäjän todennus vaaditaan",
    "Invalid rights": "Virheelliset oikeudet",
    "The object cannot be found": "Kohdetta ei löydy",
    "Content too large": "Sisältö liian suuri",
    "An unknown error occurred": "Tapahtui tuntematon virhe",
    "The action requested cannot be performed": "Pyydettyä toimenpidettä ei voida suorittaa",
    "Go": "Mene",
    "Actual / monitoring (month)": "Toteutunut / seuranta (kuukausi)",
    "Actual": "Varsinainen",
    "Month": "Kuukausi",
    "I’m setting up your account": "Olen määrittämässä tiliäsi",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Tiesitkö, että Ukun käyttöön ottaneet tilitoimistot voivat palvella 38% useampia asiakkaita samanaikaisesti.",
    "Let’s setup your company": "Perustetaan yrityksesi",
    "Name of your company": "Yrityksen nimi",
    "Size of your team?": "Tiimisi koko?",
    "Which software are you using?": "Mitä ohjelmistoa käytät?",
    "This knowledge will help us to improve Uku": "Tämä tieto auttaa meitä parantamaan Ukua",
    "What other software needs to be integrated?": "Mitä muita ohjelmistoja on integroitava?",
    "Book a demo": "Tilaa demo",
    "Hi {0},": "Hei {0},",
    "NO BOTS - ONLY HUMANS": "EI BOTTEJA - VAIN IHMISIÄ",
    "Start a {0} day free trial": "Start a {0} day free trial",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "\"Uku on uskomattoman toimiva ohjelmisto. Uku tehosti työnjohtoamme ja auttaa meitä tarjoamaan poikkeuksellista palvelua.\"",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Nopein tapa päättää, voiko Uku hyötyä {0}, on lyhyt {1} minuutin puhelu asiakasperehdytysasiantuntijamme kanssa.",
    "Hi, I'm Uku ": "Hei, olen Uku ",
    "I help to set up your account.": "Autan tilin perustamisessa.",
    "It only takes a minute.": "Se vie vain minuutin.",
    "Choose": "Valitse",
    "Your country": "Maasi",
    "Your language": "Sinun kielesi",
    "Begin": "Aloita",
    "Let’s become friends": "Meistä tulee ystäviä",
    "Your first name": "Etunimesi",
    "What is your field of work?": "Mikä on työalasi?",
    "Your field of work": "Sinun työalasi",
    "How will you use Uku?": "Miten käytät Ukua?",
    "How did you hear about Uku?": "Miten kuulit Ukusta?",
    "Choose channel": "Valitse kanava",
    "Please specify how you heard about us": "Kerro, miten kuulit meistä",
    "Let me know Uku's new features by email": "Kerro minulle Ukun uusista ominaisuuksista sähköpostitse",
    "Finish": "Valmis",
    "First name is required": "Etunimi vaaditaan",
    "Name is required": "Nimi on pakollinen",
    "Team size is required": "Joukkueen koko vaaditaan",
    "Surname is required": "Sukunimi vaaditaan",
    "Field is required": "Pakollinen kenttä",
    "I will use Uku to work together with two or more teammates.": "Käytän Ukua kahden tai useamman joukkuetoverin kanssa.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Käytän Ukua yksin. Tämä suunnitelma on ilmainen, mutta ominaisuudet ovat rajalliset.",
    "Media": "Media",
    "Through integration partner": "Integraatiokumppanin kautta",
    "Referral by friend": "Ystävän viittaus",
    "Import speeds up your clients setup, smart choice!": "Tuonti nopeuttaa asiakkaidesi asennusta, fiksu valinta!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Viimeisin tuonti: lisätty {0}, päivitetty {1}, ohitettu {2}, {3} asiakkaan tuonti epäonnistui",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Viimeisin tuonti: lisätty {0}, päivitetty {1}, ohitettu {2}, {3}-asiakkaiden tuonti epäonnistui",
    "Last import: added {0}, updated {1}, skipped {2}": "Viimeisin tuonti: lisätty {0}, päivitetty {1}, ohitettu {2}",
    "What's next? Correct the data of {0} clients and upload again.": "Mitä seuraavaksi? Korjaa {0} asiakkaiden tiedot ja lataa ne uudelleen.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX) ",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Sen sijaan, että kirjoittaisit asiakkaat yksitellen, voit käyttää tiedostojen tuontia suurelle asiakaskunnalle.",
    "Ignore": "Ohita",
    "NEW CLIENT": "UUSI ASIAKAS",
    "Preview": "Esikatselu",
    "Import started": "Tuonti alkoi",
    "Only new clients": "Vain uusia asiakkaita",
    "Update data from company register": "Päivitä tiedot yritysrekisteristä",
    "If switched on, the company data is updated using the local business register": "Jos toiminto on käytössä, yrityksen tiedot päivitetään paikalliseen kaupparekisteriin",
    "We did not find a match in Äriregister": "Emme löytäneet vastinetta Äriregisteristä",
    "We did not find a match in Companies House": "Emme löytäneet vastinetta Companies Housesta",
    "No integration yet": "Ei vielä integraatiota",
    "Uku match": "Uku-ottelu",
    "Business register nr.": "Kaupparekisteri nro.",
    "Company register": "Yritysrekisteri",
    "Upload file": "Lähetä tiedosto",
    "Before uploading your file": "Ennen tiedoston lataamista",
    "Learn Uku’s data structure": "Tutustu Ukun tietorakenteeseen",
    "Download and use our sample file to see exactly how we organize data in Uku": "Lataa ja käytä mallitiedostoamme nähdäksesi tarkalleen, miten järjestämme tiedot Ukussa",
    "Download Client Import Example": "Lataa esimerkki asiakkaan tuonnista",
    "Download Contact Import Example": "Lataa yhteystietojen tuonnin esimerkki",
    "Fill in fields": "Täytä kentät",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Ainoa pakollinen kenttä on yrityksen nimi. Varmista, että olet täyttänyt kaikki tarvittavat kentät ennen tiedoston lataamista.",
    "Learn more about mandatory fields": "Lisätietoja pakollisista kentistä",
    "Create custom fields": "Mukautettujen kenttien luominen",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Jotkin tietokentät eivät ehkä ole oletusarvoisesti käytettävissä. Varmista, että luot nämä mukautetut kentät ennen tietojen tuomista.",
    "Add new custom fields": "Uusien mukautettujen kenttien lisääminen",
    "...or drag a file here": "... tai vedä tiedosto tähän",
    "Only Excel (.xls, .xlsx) file types are supported": "Vain Excel-tiedostotyyppejä (.xls, .xlsx) tuetaan",
    "Mapping": "Kuvaus",
    "First row is a header": "Ensimmäinen rivi on otsikko",
    "Add field to all clients": "Lisää kenttä kaikkiin asiakkaisiin",
    "Add client group": "Lisää asiakasryhmä",
    "Fields for all clients": "Kaikkien asiakkaiden kentät",
    "Import of {0} in progress": "Käynnissä olevien {0} tuonti",
    "Import in progress": "Tuonti käynnissä",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Se voi kestää jonkin aikaa. Voit tehdä muita aktiviteetteja Ukussa samaan aikaan, ilmoitamme sinulle, kun se on valmis.",
    "Cancel import": "Peruuta tuonti",
    "Are you sure you want to cancel import?": "Haluatko varmasti peruuttaa tuonnin?",
    "Last updated": "Päivitetty viimeksi",
    "Contracts": "Sopimukset",
    "Job name": "Palvelun nimi",
    "Workflow name": "Työnkulun nimi",
    "Details": "Lisätiedot",
    "Select jobs": "Valitse työpaikat",
    "Select task plan": "Valitse tehtäväsuunnitelma",
    "of existing client": "olemassa olevasta asiakkaasta",
    "You can also choose": "Voit myös valita",
    "existing client tasks plan": "Olemassa oleva asiakkaan tehtäväsuunnitelma",
    "existing predefined jobs": "olemassa olevat ennalta määritetyt työpaikat",
    "create a new plan": "luo uusi suunnitelma",
    "Select workflow": "Valitse työnkulku",
    "existing project workflow": "Aiemmin luotu projektin työnkulku",
    "existing workflow": "Olemassa oleva työnkulku",
    "create a new workflow": "Uuden työnkulun luominen",
    "New tasks template": "Uusi tehtävämalli",
    "to save template!": "tallentaaksesi mallin!",
    "You can also add tasks from jobs": "Voit myös lisätä tehtäviä töistä",
    "or choose": "tai valitse",
    "New workflow template": "Uusi työnkulkumalli",
    "You can also add tasks from existing workflow templates": "Voit myös lisätä tehtäviä aiemmin luoduista työnkulkumalleista",
    "existing event workflow": "Olemassa oleva tapahtumatyönkulku",
    "Hide others": "Muiden piilottaminen",
    "Update all events (New tasks)": "Päivitä kaikki tapahtumat (Uudet tehtävät)",
    "Update all projects (New tasks)": "Päivitä kaikki projektit (Uudet tehtävät)",
    "Once": "Kerran",
    "Once a month": "Kerran kuukaudessa",
    "Once a quarter": "Kerran vuosineljänneksenä",
    "Once a year": "Kerran vuodessa",
    "Company workflow": "Yrityksen työnkulku",
    "Company jobs": "Yrityksen työpaikat",
    "Default jobs": "Oletustyöt",
    "ID": "ID",
    "Task title and labels": "Tehtävän otsikko ja otsikot",
    "Assigned and time": "Määritetty ja aika",
    "Setup tasks for {0} event": "Tapahtuman {0} määritystehtävät",
    "Setup tasks for {0} project": "Projektin {0} määritystehtävät",
    "New job": "Uusi työ",
    "Edit job": "Muokkaa työtä",
    "New workflow": "Uusi työnkulku",
    "Save workflow": "Tallenna työnkulku",
    "Confirm task plan": "Vahvista tehtäväsuunnitelma",
    "Skip": "Ohita",
    "Create task plan": "Luo tehtäväsuunnitelma",
    "Edit task plan": "Edit task plan",
    "Confirm workflow": "Vahvista työnkulku",
    "Client portal templates": "Asiakasportaalin mallit",
    "Jobs": "Työpaikat",
    "Workflows": "Työnkulut",
    "Company workflows": "Yrityksen työnkulut",
    "Default workflows": "Oletustyönkulut",
    "Company template saved": "Yritysmalli tallennettu",
    "Company template created": "Yritysmalli luotu",
    "Format": "Muoto",
    "Currency": "Valuutta",
    "Reference number": "Viitenumero",
    "Invoice description": "Laskun kuvaus",
    "Summarize invoice rows": "Laskurivien yhteenvedon tekeminen",
    "Summarized description": "Yhteenveto kuvaus",
    "Reverse charge": "Käännetty verovelvollisuus",
    "Rounding": "Pyöristys",
    "Time rounding will apply for each line": "Aikapyöristystä sovelletaan jokaiselle riville",
    "Rounding increment (up)": "Pyöristäminen (ylös)",
    "Reply to": "Vastaa",
    "Configuration": "Asetukset",
    "Invoice to parent company": "Lasku emoyhtiölle",
    "Create all invoices under parent company.": "Luo kaikki laskut emoyhtiön alla.",
    "User code": "Käyttäjän koodi",
    "Default": "Oletus",
    "Default value will apply for each line": "Oletusarvoa sovelletaan jokaiselle riville",
    "Number": "Numero",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Voit kirjoittaa minkä tahansa seuraavista aaltosulkeista laskun etuliitteeseen kenttään. Kun tallennat sopimuksen, etuliite täytetään vastaavalla arvolla.",
    "Copy to clipboard": "Kopioi leikepöydälle",
    "Invoice previous period": "Laskuta edellinen kausi",
    "Invoice period": "Laskun kausi",
    "Invoice next period": "Laskuta seuraavalla kaudella",
    "Client primary user": "Asiakkaan ensisijainen käyttäjä",
    "Original client name": "Alkuperäinen asiakkaan nimi",
    "invoice date year": "laskun päivämäärä vuosi",
    "last two digits of invoice date year": "Laskun päivämäärävuoden kaksi viimeistä numeroa",
    "invoice date month": "laskun päivämäärä kuukausi",
    "invoice date day": "Laskun päivämäärän päivä",
    "Contract": "Sopimus",
    "Net total": "Net total",
    "Contract #": "Sopimus #",
    "Invoice #": "Laskun nro",
    "Exported": "Viedä",
    "Sent": "Lähetetty",
    "Net": "Netto",
    "Add invoice": "Lisää lasku",
    "Change invoice number": "Laskun numeron muuttaminen",
    "Review changes": "Tarkista muutokset",
    "Please review and approve changes to the related events": "Tarkista ja hyväksy muutokset tapahtumiin liittyviin tapahtumiin",
    "Please review and approve changes to the related projects": "Tarkista ja hyväksy muutokset liittyviin projekteihin",
    "Contains": "Sisältää",
    "contains": "sisältää",
    "Exactly": "Tarkalleen",
    "is exactly": "on täsmälleen",
    "Greater than": "Suurempi kuin",
    "is greater than": "on suurempi kuin",
    "Less than": "Pienempi kuin",
    "is less than": "on pienempi kuin",
    "Range": "Jakso",
    "is in range of": "on alueella",
    "is empty": "on tyhjä",
    "Task plan": "Tehtäväsuunnitelma",
    "Edit plan": "Muokkaa suunnitelmaa",
    "Use task plan templates to set up tasks effectively or add a task manually": "Määritä tehtävät tehokkaasti tai lisää tehtävä manuaalisesti tehtäväsuunnitelmamallien avulla",
    "Add task manually": "Tehtävän lisääminen manuaalisesti",
    "Quarterly": "Neljännesvuosittain",
    "Export excel": "Vie excel",
    "Print PDF": "Tulosta PDF",
    "Edit jobs": "Muokkaa työpaikkoja",
    "Replace plan tasks with job": "Suunnittelutehtävien korvaaminen työllä",
    "Select template": "Valitse malli",
    "member": "jäsen",
    "Tasks with user will be added to every selected client": "Tehtävät, joilla on käyttäjä, lisätään jokaiseen valittuun asiakkaaseen",
    "Add even if job already applied": "Lisää, vaikka työpaikka olisi jo haettu",
    "Default user": "Oletuskäyttäjä",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Tämä poistaa kaikki tehtävät asiakassuunnitelmasta ja lisää siihen vain valitun mallin tehtävät",
    "Adding template will be ready in a minute. You can continue with work.": "Mallineen lisääminen kestää minuutin. Voit jatkaa työtä.  ",
    "Add client": "Lisää asiakas",
    "Export clients": "Vie asiakkaita",
    "Export client contacts": "Asiakkaan yhteystietojen vieminen",
    "client | clients": "Asiakas | Asiakkaat",
    "clients": "asiakasta",
    "client(s) had errors": "Asiakkaalla (asiakkailla) oli virheitä",
    "client(s) selected": "Asiakas (valitut asiakkaat)",
    "Contract actions": "Sopimuskanteet",
    "Edit Members": "Muokkaa jäseniä",
    "Edit monitoring": "Muokkaa seurantaa",
    "Your company": "Sinun yrityksesi",
    "Edit billing": "Muokkaa laskutusta",
    "Activate client portal": "Aktivoi asiakasportaali",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "Aktivoinnin jälkeen voit lähettää tehtäviä suoraan kaikille asiakkaan yhteyshenkilöille, joilla on sähköpostiosoite.",
    "Send welcome invitation to client contacts": "Lähetä tervetulokutsu asiakkaan yhteyshenkilöille",
    "Who will receive an invitation?": "Kuka saa kutsun?",
    "Client contact who has one valid e-mail address": "Asiakkaan yhteyshenkilö, jolla on yksi kelvollinen sähköpostiosoite",
    "Client contact who has the client's portal open (default for all)": "Asiakasyhteyshenkilö, jolla on asiakasportaali avoinna (oletus kaikille)",
    "How does the invitation work?": "Miten kutsu toimii?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku luo ja lähettää \"Tervetuloa-tehtävän\" jokaiselle asiakaskontaktille. Asiakkaan ensisijainen käyttäjä luo sen Tervetuloa asiakasportaaliin -tehtävämallin perusteella. Tarkista se yrityksesi tehtävämalleista. Se käännetään yhteyskielen mukaan.",
    "Uku client portal always informs clients by email about new tasks.": "Uku-asiakasportaali tiedottaa asiakkaille uusista tehtävistä aina sähköpostitse.",
    "View templates": "Näytä pohjat",
    "Client portal activated": "Asiakasportaali aktivoitu",
    "Company's name": "Yrityksen nimi",
    "Mark": "Mark",
    "Add members": "Lisää jäseniä",
    "Members and groups": "Jäsenet ja ryhmät",
    "Topic is required": "Aihe on pakollinen",
    "Entering time is required": "Syöttöaika vaaditaan",
    "Delete client": "Poista asiakas",
    "Manage client fields": "Asiakaskenttien hallinta",
    "Max 3 characters": "Enintään 3 merkkiä",
    "Are you sure you wish to delete this client?": "Haluatko varmasti poistaa tämän asiakkaan?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "Asiakastietojen poistaminen poistaa myös kaikki asiakkaaseen liittyvät tehtävät.<br/><br/>HUOM! Asiakashistoria poistetaan",
    "Owner": "Omistaja",
    "All clients that you add under {0} will be deleted later.</div>": "Kaikki asiakkaat, jotka lisäät kohtaan {0} , poistetaan myöhemmin.",
    "Use this account for testing purposes only!": "Käytä tätä tiliä vain testaustarkoituksiin!",
    "Read more about the demo account": "Lue lisää demotilistä",
    "Rights": "Käyttöikeudet",
    "Monitoring setup": "Valvonnan asetukset",
    "Learn more about monitoring": "Lue lisää seurannasta",
    "selected": "valittu",
    "Resend": "Resend",
    "Invoicing": "Laskujen esittäminen ",
    "Billing template": "Laskutusmalli",
    "New": "Uusi",
    "Add row": "Lisää rivi",
    "Delete contract": "Poista sopimus",
    "Product / description": "Tuote / kuvaus",
    "Qty": "Kpl",
    "Product placeholders": "Tuotteen paikkamerkit",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.",
    "Template saved": "Mallipohja tallennettu",
    "Warning": "Varoitus ",
    "Would you like to apply these changes to all clients using this contract template?": "Haluatko soveltaa näitä muutoksia kaikkiin tätä sopimusmallia käyttäviin asiakkaisiin?",
    "Yes, apply to all clients": "Kyllä, koskee kaikkia asiakkaita",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Olet muuttanut tätä laskutussopimusta koskevaa ajanjaksoa. Se voi vaikuttaa laskuttamattomien palveluiden laskujen laskutukseen. Vahvista, että tämä muutos on tahallinen. ",
    "Are you sure to delete this template?": "Oletko varma, että poistat tämän mallin?",
    "Save template": "Tallenna malli",
    "Save as template": "Tallenna mallipohjana",
    "Please note all changes made to contract will be lost": "Huomaa, että kaikki sopimukseen tehdyt muutokset menetetään",
    "Add contract": "Lisää sopimus",
    "Manage contract templates": "Sopimusmallien hallinta",
    "Edit account details": "Muuta tilin tietoja",
    "Country is required": "Maa / Alue vaaditaan",
    "Postal code": "Postinumero",
    "State": "Osavaltio",
    "Uku is set up according to the field of work.": "Uku perustetaan työalan mukaan.",
    "Size of the team": "Joukkueen koko",
    "Website": "Website",
    "Delete account": "Poista tili",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Tilin poistaminen poistaa myös kaikki tiliin liittyvät asiakkaat, heidän tehtävänsä ja koko historiansa. Oletko varma, että haluat poistaa tilisi?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Kyllä, poista tili ja kaikki siihen liittyvät tiedot, kuten asiakkaat, tehtävät ja koko historia",
    "These invoices cannot be sent. Check their status or error messages.": "Näitä laskuja ei voi lähettää. Tarkista niiden tila tai virheilmoitukset.",
    "Please confirm that you wish to proceed.": "Vahvista, että haluat jatkaa.",
    "Sending invoice | Sending invoices": "Laskun lähettäminen | Laskujen lähettäminen",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Olet lähettämässä tätä laskua asiakkaalle sähköpostitse. | Olet lähettämässä näitä laskuja asiakkaille sähköpostitse.",
    "Error in calculating invoice": "Virhe laskun laskennassa",
    "Error in importing invoice": "Virhe laskun tuonnissa",
    "Error in creating invoice": "Virhe laskun luomisessa ",
    "Error in exporting invoice": "Virhe laskun viennissä",
    "Error in sending invoice": "Virhe laskun lähettämisessä",
    "Calculating invoice": "Laskun laskeminen",
    "Creating invoice": "Laskua luodaan",
    "Exporting invoice": "Laskua viedään",
    "Importing invoice": "Laskun tuominen",
    "Sending invoice": "Laskua lähetetään",
    "Clear errors": "Tyhjää virheet",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Liittyvät työt muuttuvat taas laskutettaviksi. Laskuja ei poisteta ulkoisista järjestelmistä – se sinun on tehtävä manuaalisesti.",
    "Delete invoice | Deleting invoices": "Poista lasku | Laskujen poistaminen",
    "Selected net total": "Selected net total",
    "Nothing in invoices": "Laskuja ei löytynyt",
    "Please make sure you have setup recurring billing for your clients": "Varmista, että olet asettanut asiakkaillesi toistuvan laskutuksen ",
    "Draft": "Luonnos",
    "Approval": "Hyväksyntä",
    "Created": "Luotu",
    "Coming soon": "Tulossa pian",
    "Selected invoices and related product info will be sent to accounting system.": "Valitut laskut ja niihin liittyvät tuotetiedot lähetetään kirjanpitojärjestelmään. ",
    "Piece": "Kappale",
    "Hour": "Tunti",
    "Delete row": "Poista rivi",
    "Out of ": "Valitud",
    " can be created": "voi luoda",
    "For ": "Varten",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " laskutusjakso jatkuu edelleen. Laskun luomisen jälkeen tällä jaksolla tehtyjä töitä ei laskuteta.",
    "Invoice date will be set to today.": "Laskun päivämääräksi asetetaan tämä päivä.",
    "Uku is about to create": "Uku on luomassa",
    " selected row, only | selected row, only ": " Vain valittu rivi | Vain valittu rivi ",
    " invoice | invoices": " Lasku | Laskut",
    "These invoices cannot be exported. Check their status or error messages.": "Näitä laskuja ei voi viedä. Tarkista niiden tila tai virheilmoitukset.",
    "Exporting invoice | Exporting invoices": "Laskun vienti | Laskujen vienti",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Olet viemässä tätä laskua kirjanpitoon. | Olet viemässä näitä laskuja kirjanpitoon.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?",
    "Download pdf": "Lataa pdf",
    "Create invoice": "Luo lasku",
    "Update status from {0}": "Päivitä tila {0}",
    "Show all lines": "Näytä kaikki rivit",
    "Calculate invoice": "Laske lasku",
    "Loading invoice...": "Laskua ladataan...",
    "Invalid Scoro credentials": "Virheelliset Scoron tunnukset",
    "Please confirm the changes you have made to this invoice.": "Vahvista, että haluat tallentaa tähän laskuun tekemäsi muutokset.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "HUOM! Muutettua laskua ei lähetetä automaattisesti asiakkaalle eikä viedä kolmansille osapuolille – nämä toimenpiteet sinun on tehtävä manuaalisesti.",
    "Invoice number already exists! Please confirm to save anyway.": "Laskun numero on jo olemassa! Vahvista tallennus joka tapauksessa.",
    "Error in data": "Virhe tiedoissa",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Laskutusjakso jatkuu vielä. Laskun luomisen jälkeen tällä jaksolla tehtyjä töitä ei laskuteta. ",
    "Creation date": "Luontipäivä",
    "{0} days after": "{0} päivän kuluttua",
    "{0} day after": "{0} päivä sen jälkeen",
    "right away when": "heti, kun",
    "start date": "Aloituspäivä",
    "due date": "eräpäivä",
    "finished": "valmis",
    "Entries count": "Osallistumisten määrä",
    "Entries excluding sales": "Kirjaukset ilman myyntiä",
    "Entries excluding bank": "Merkinnät ilman pankkia",
    "Entries excluding documents": "Merkinnät ilman asiakirjoja",
    "Documents (sales and purchases)": "Asiakirjat (myynnit ja ostot)",
    "Cash entries": "Käteistapahtumat",
    "VAT entries": "ALV-kirjaukset",
    "Stock entries": "Varastomerkinnät",
    "Sale entries": "Myynti-ilmoitukset",
    "Purchase entries": "Ostotapahtumat",
    "Bank entries": "Pankin merkinnät",
    "Ledger entries": "Kirjanpitotapahtumat",
    "Depreciation entries": "Poistokirjaukset",
    "Entry lines count": "Syöttörivien määrä",
    "Transaction create": "Transaction create",
    "Transaction update": "Transaction update",
    "Purchase invoice create": "Purchase invoice create",
    "Purchase invoice update": "Purchase invoice update",
    "Sales invoice create": "Sales invoice create",
    "Sales invoice update": "Sales invoice update",
    "Financial entry create": "Financial entry create",
    "Financial entry update": "Financial entry update",
    "Expense row create": "Expense row create",
    "Expense row update": "Expense row update",
    "Depreciation create": "Depreciation create",
    "Depreciation update": "Depreciation update",
    "Person count": "Person count",
    "Fixed assets": "Fixed assets",
    "Company owner": "Yrityksen omistaja",
    "Activity": "Aktiviteetti",
    "Oldest first": "Vanhin ensin",
    "Newest first": "Uusin ensin",
    "Quantity as time": "Määrä aikana",
    "Quantity as number": "Määrä numerona",
    "Quantity as time in number format": "Määrä aikana lukumuodossa",
    "No rounding": "Ei pyöristystä",
    "min": "min",
    "hour": "tunti",
    "Last day of month": "Kuukauden viimeinen päivä",
    "Invoice line": "Laskun rivi",
    "Task time total (per member)": "Tehtäväaika yhteensä (jäsentä kohti)",
    "Time entry": "Ajan syöttö",
    "Task finish date": "Tehtävän päättymispäivä",
    "Create separately": "Luo erikseen",
    "Merge into one": "Yhdistä yhdeksi",
    "No minimum": "Minimi puuttuu",
    "{0} minute": "{0} minuutti",
    "{0} minutes": "{0} minuuttia",
    "{0} hour": "{0} tunti",
    "{0} hours": "{0} tuntia",
    "English": "englanti",
    "Estonian": "viro",
    "Danish": "tanska",
    "Lithuanian": "Liettua",
    "Russian": "venäjä",
    "Finnish": "suomi",
    "Swedish": "ruotsi",
    "Norwegian": "norja",
    "Latvian": "Latvia",
    "Bulgarian": "Bulgaria",
    "German": "Saksa",
    "Spanish": "Espanja",
    "Polish": "Puola",
    "Field: ": "Kenttä:",
    "Normal hours": "Normaalitunnit",
    "Year": "Vuosi",
    "Estonia": "Eesti",
    "Finland": "Suomi",
    "Poland": "Puola",
    "User": "Käyttäjä",
    "None": "Ei mitään",
    "Error!": "Virhe!",
    "Pending": "Odottaa",
    "Finished": "Valmistunut",
    "Text": "Teksti",
    "Choice": "Valinta",
    "Yes/No": "Ja/Nein",
    "Integer": "Kokonaisluku",
    "Multiple choice": "Monivalinta",
    "URL": "URL",
    "Multiple users": "Useita käyttäjiä",
    "Multiline text": "Monirivinen teksti",
    "Must be a integer": "On oltava kokonaisluku",
    "Must be a date": "On oltava päivämäärä",
    "Must be a valid e-mail address": "On oltava kelvollinen sähköpostiosoite",
    "Unknown choice": "Tuntematon valinta",
    "Some errors occurred:": "Tapahtui joitakin virheitä:",
    "Unknown network error": "Tuntematon verkkovirhe",
    "Could not connect to the service": "Yhteyden muodostaminen palveluun ei onnistunut",
    "Reload this page": "Lataa tämä sivu uudelleen",
    "Invoice paid": "Lasku maksettu",
    "Annulled": "Mitätöity",
    "Processing": "Käsittelyssä",
    "You are about to deactivate this app.": "Olet poistamassa tämän sovelluksen käytöstä.",
    "You are about to disconnect this app.": "Olet katkaisemassa tämän sovelluksen yhteyden.",
    "Do you also want to activate billing to get the most out of Uku?": "Haluatko myös aktivoida laskutuksen, jotta saat kaiken irti Ukusta?",
    "Invoice": "Lasku",
    "Clients - Monitoring": "Asiakkaat - Seuranta",
    "Links": "Linkit",
    "New template": "Uusi malli",
    "Import Clients from Excel": "Asiakkaiden tuominen Excelistä",
    "Importer": "Maahantuoja",
    "Import clients from Excel": "Asiakkaiden tuominen Excelistä",
    "Account settings": "Asetukset",
    "Empty": "Tyhjä",
};
export default translations